import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import CryptoJS from 'crypto-js';
import moment, { Moment } from 'moment';
import { BehaviorSubject, firstValueFrom, lastValueFrom } from 'rxjs';
import { CommonService } from 'src/app/core/services/common-service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { REGEX } from '../module/shared/constants/regex.const';
import { AddonCovers, InsighStatus, PanelState, ParamConsts, ProductCode } from '../module/shared/enums';
import { ConsentMode } from '../module/shared/enums/consentMode';
import { DateFormat } from '../module/shared/enums/date-format.enum';
import { BusinessType, CustomerType, PolicyType } from '../module/shared/enums/motor-product-type.enum';
import { PaymentModes } from '../module/shared/enums/payment-modes.enum';
import { QuoteRquestType, statusOfPolicy } from '../module/shared/enums/quote-request-type.enum';
import { CustomerKYCDetails, PaymentPayload, VerifyCustomerResult, customerDetailsFromInsight, kycDetailsResult, options, renewDetails } from '../module/shared/models';
import { PreviousPolicyDetailsFromQuote } from '../module/shared/models/previous-policy-details-from-quote.type';
import { MotorService } from './motor.service';
import { QuoteService } from './quote.service';
import { PolicyConstant } from '../Model/policyConstant';
import { InsightService } from './insight.service';
import { pcvVechicleClassCode } from 'src/app/partner-portal/module/shared/enums/vehicleClassCode';
import { AnyAaaaRecord } from 'dns';


@Injectable({
  providedIn: 'root'
})
export class ProposalService {
  smDetailForm: FormGroup;
  inspectionForm: FormGroup;
  financierForm: FormGroup;
  nomineeDetailForm: FormGroup;
  pospDetailForm: FormGroup;
  customerDetailsForm: FormGroup;
  customerConsentForm: FormGroup;
  additionalAddonInfoForm: FormGroup;
  quoteDetails: any;
  isSubmittedPoposal: boolean = false;
  isPremiumCalculated: boolean = false;
  showCustomerDetail: boolean = false;
  isOTPGenerated: boolean = false;
  proposalNo: any = '';
  isProposalOn: boolean = false;
  paymentDetailsForm: FormGroup;
  isCustomerKYCDetailsSubmitted: boolean = false;
  isPaymentSubmitted: boolean;
  verifyCustomerKycData: VerifyCustomerResult;
  isCustomerConsentSubmitted: boolean;
  isOtpSending: boolean;
  isOTPInvalid: boolean = false;
  isOTPTimedOut: boolean = false;
  pincodeDetails: { stateName?: string; pinCode?: string; cityDistrictName?: string; stateCode?: string; locationCode?: string; cityDistrictCode?: string; };
  isShortFall: boolean;
  isKycStatusOk: boolean = false;
  branchCode: string;
  panNo: string;
  paymentPayload: PaymentPayload;
  insuredname: string;
  selectedDocument: string;
  isTrailerAttached: boolean;
  private resendEndormentOtpSubject = new BehaviorSubject<boolean | false>(false);
  resendEndormentOtp$ = this.resendEndormentOtpSubject.asObservable();
  requiredDocuments: string[];
  isFormInitOff: boolean = false;
  isKycFraud: boolean = false;
  agreeWithTermsAndCondition: boolean = false;
  isKycDocumnetUploadButton: boolean = false;
  isKycDocumnetUploaded: boolean = false;
  isKYCSucess: boolean = false;
  isKYC_Complete: boolean = false;
  base64String: string = '';
  isDeviations: boolean = false;
  tpPolicyMinStartDate: Date;
  isCustomerKycPatched$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  searchCustomerForm: FormGroup;
  isInspectionByPass: boolean = false;
  kycInitiatedBy: string = '';
  disableCancellationDeleteButton: boolean = false;
  disableConsentMode: boolean = false;
  isConfirmOfHavingValidPersonalAccidentPolicy: boolean = false;
  kycByCustomerOnly: boolean = false;
  missingDocs: any = '';
  byPassValidation: boolean = false;
  pcvVehicleClassCode = pcvVechicleClassCode;
  isManualInspection = false;
  emailPaymentLink: any;
  public isDiscountOrLoadingPerOutOfRange: boolean = false;
  constructor(private motorService: MotorService,
    private quoteService: QuoteService,
    private notificationService: NotificationService,
    private commonService: CommonService,
    private router: Router,
    private decimalPipe: DecimalPipe,
    private insightService: InsightService
  ) { }
  getNomineeForm() {
    return new FormGroup({
      nomineeName: new FormControl(''),
      nomineeAge: new FormControl(''),
      nomineeRelationship: new FormControl(''),
      appointeeName: new FormControl(''),
      appointeeAge: new FormControl(''),
      appointeeRelationship: new FormControl(''),
      minor: new FormControl(false),
    });
  }
  getFinancierForm(): FormGroup {
    return new FormGroup({
      agreementType: new FormControl(''),
      financierName: new FormControl(''),
      financierAddress: new FormControl(''),
    });
  }
  getPospForm(): FormGroup {
    return new FormGroup({
      pospName: new FormControl(''),
      pospCode: new FormControl(''),
      pospPan: new FormControl(''),
      pospAadhar: new FormControl('')
    });
  }

  getInspectionDetails() {
    this.inspectionForm = new FormGroup({
      isInspectionCompleted: new FormControl(''),
      inspectionType: new FormControl(''),
      inspectionReferenceNumber: new FormControl(''),
      reportDate: new FormControl(''),
      inspectionDate: new FormControl(''),
      inspectionTime: new FormControl(''),
      inspectionDoneBy: new FormControl(''),
      reportStatus: new FormControl(''),
      inspectionMode: new FormControl(''),
      inspectionPartner: new FormControl(''),
      currentYearNcbPerc: new FormControl(''),
      intimatorName: new FormControl(''),
      intimatorContactNo: new FormControl(''),
      intimatorEmailId: new FormControl(''),
      appointmentDate: new FormControl(''),
      appointmentTime: new FormControl(''),
      appointmentAddressLine1: new FormControl(''),
      appointmentAddressLine2: new FormControl(''),
      appointmentPinCode: new FormControl(''),
      appointmentCity: new FormControl(''),
      appointmentState: new FormControl(''),
      coverNoteIssuanceDateAndTime: new FormControl('')
    })
  }
  getCustomerKYCDetailsForm(): FormGroup {
    let nameObj = this.getNameSurname();
    return new FormGroup({
      firstName: new FormControl(),
      salutation: new FormControl(''),
      selectedDocument: new FormControl(''),
      lastName: new FormControl(nameObj?.surname),
      middleName: new FormControl(''),
      companyName: new FormControl(''),
      gender: new FormControl(''),
      dob: new FormControl('', Validators.required),
      isGstNumber: new FormControl(false),
      gstStateName: new FormControl(""),
      gstinNumber: new FormControl(""),
      gstinNumber1: new FormControl(""),
      gstinNumber2: new FormControl(""),
      gstinNumber3: new FormControl(""),
      doi: new FormControl(''),
      mobileNo: new FormControl('', [Validators.required, Validators.pattern('^[6-9][0-9]{9}$')]),
      email: new FormControl('', [Validators.email]),
      proposerPAN: new FormControl('', [Validators.pattern(REGEX.panNumber)]),
      proposerAadhaarNumber: new FormControl('', [Validators.minLength(4)]),
      proposerCKYCNo: new FormControl('', [Validators.minLength(14)]),
      pinCode: new FormControl(''),
      state: new FormControl(''),
      city: new FormControl(''),
      mailingAreaOrLocality: new FormControl(''),
      mailingTownOrCity: new FormControl(''),
      mailingDistrictCd: new FormControl(''),
      mailingStateCd: new FormControl(''),
      mailingDistrict: new FormControl(''),
      permanentAddress: new FormControl('', [Validators.minLength(5), Validators.maxLength(300)]),
      permanentAddress2: new FormControl('', [Validators.minLength(5), Validators.maxLength(300)]),
      permanentAddressPincode: new FormControl(''),
      permanentAddressState: new FormControl(''),
      permanentAddressCity: new FormControl(''),
      otherAddFLD1: new FormControl('', [Validators.minLength(5), Validators.maxLength(300)]),
      otherAddFLD2: new FormControl(''),
      otherAddFLD3: new FormControl(''),
      otherAddFLD4: new FormControl(''),
      otherAddFLD5: new FormControl(''),
      otherAddFLD6: new FormControl(''),
      fileName: new FormControl(''),
      file: new FormControl(''),
      selectedKYCDocument: new FormControl(''),
      fileType: new FormControl(''),
      kycInitiatedBy: new FormControl('', []),
    });
  }
  getPaymentDetailsForm(): FormGroup {
    const AMOUNT = this.motorService?.premiumBreakupData?.premiumDetails?.totalPremiumIncludingTax || 0;
    return new FormGroup({
      paymentMode: new FormControl(''),
      paymentBy: new FormControl(''),
      amount: new FormControl(AMOUNT),
      paymentDueDate: new FormControl(''),
      instrumentNo: new FormControl(''),
      chequeSubmissionThrough: new FormControl(''),
      panNo: new FormControl(''),
      transactionNo: new FormControl(''),
      bankName: new FormControl(''),
      branchName: new FormControl(''),
      totalPrem: new FormControl(''),
      totalPremSelected: new FormControl(0),
      shortFallValue: new FormControl(''),
      excessValue: new FormControl(''),
      collectionSystem: new FormControl(''),
      fullName: new FormControl(''),
      email: new FormControl(''),
      mobileNo: new FormControl(''),
      isAdvancePaymentForPos: new FormControl(false),
      selectCustomer: new FormControl(''),
    });
  }


  getCustomerConsentForm(): FormGroup {
    return new FormGroup({
      agreeWithTermsAndCondition: new FormControl(false),
      consentMode: new FormControl(''),
      emailIndicator: new FormControl(false),
      whatsAppIndicator: new FormControl(false),
      partnerCopyIndicator: new FormControl(false),
      paymentBehalfIndicator: new FormControl(false),
      smsIndicator: new FormControl(false),
      endorsementNumber: new FormControl(''),
      otp: new FormControl('', [
        Validators.pattern(/^[0-9]*$/),
        Validators.minLength(6),
        Validators.maxLength(6)
      ]),
      mobileNumber: new FormControl('')
    });
  }
  getAdditionalAddonInfoForm(): FormGroup {
    return new FormGroup({
      tyreSerialNo1: new FormControl('', Validators.required),
      tyreSerialNo2: new FormControl('', Validators.required),
      tyreSerialNo3: new FormControl('', Validators.required),
      tyreSerialNo4: new FormControl('', Validators.required),
      tyreSerialNo5: new FormControl('', Validators.required),
    });
  }

  getSearchCustomerForm(): FormGroup {
    return new FormGroup({
      firstName: new FormControl('', Validators.pattern('^[a-zA-Z ]{2,}$')),
      lastName: new FormControl('', Validators.pattern('^[a-zA-Z ]{2,}$')),
      mobile: new FormControl('', Validators.pattern('^[6-9]\\d{9}$')),
      email: new FormControl('', Validators.email)
    });
  }
  get isPaymentModeOnline(): boolean {
    return (this.paymentDetailsForm?.controls?.paymentMode?.value === PaymentModes.ONLINE);
  }

  get isPaymentModeEmailLink(): boolean {
    return this.paymentDetailsForm?.controls?.paymentMode?.value === PaymentModes.EMAILS_PAYMENT_LINK;
  }

  get customerDetailsFormControls() {
    return this.customerDetailsForm?.controls;
  }
  patchBusinessForm(businessDetails: any) {
    let proposalBuisnessType = {
      businessType: businessDetails?.vehicleDetails?.businessType === statusOfPolicy.Renewal ? statusOfPolicy.Renew : businessDetails?.vehicleDetails?.businessType,
      customerType: businessDetails?.vehicleDetails?.customerType,
      productType: businessDetails?.quoteDetails?.productType,
      vehicleClass: businessDetails?.vehicleDetails?.vehicleClass,
      vehicleSubClass: businessDetails?.vehicleDetails?.vehicleSubClass,
      vehicleSegment: businessDetails?.vehicleDetails?.vehicleSegment,
      rtoCode: `${businessDetails.vehicleDetails.rtoCode} ${businessDetails.vehicleDetails.registrationPlace} Zone ${businessDetails.vehicleDetails.rtoZone}`,
      chassisNo: businessDetails?.vehicleDetails?.chassisNo,
      registrationNo: businessDetails?.vehicleDetails?.vehicleRegistrationNo,
      productCode: businessDetails?.vehicleDetails?.productCode,
      vehicleClassDescription: businessDetails?.vehicleDetails?.vehicleClassDescription || "",
      vehicleSubClassCode: businessDetails?.vehicleDetails?.vehicleSubClassCode || 0,
    }
    this.motorService.vehicleSegmentClass = businessDetails?.vehicleDetails?.vehicleSubClassCode || 0;
    this.motorService.rtoCode = {
      registrationZone: businessDetails?.vehicleDetails?.rtoZone,
      rtoLocationCode: businessDetails?.vehicleDetails?.rtoCode,
      rtoLocationName: businessDetails?.vehicleDetails?.registrationPlace
    }
    this.motorService.currentBtType = businessDetails.vehicleDetails.businessType;
    this.motorService.segment = businessDetails?.vehicleDetails?.vehicleSegment || '';
    this.motorService.productCode = businessDetails?.vehicleDetails?.productCode || "";
    this.motorService.gcProductCode = businessDetails?.vehicleDetails?.gcProductCode || '';
    this.motorService.segment = businessDetails?.vehicleDetails?.vehicleSegment || '';
    this.motorService.vehicleClassCode = Number(businessDetails?.vehicleDetails?.vehicleClassCode);
    this.motorService.commericalVehicleClassCode = Number(businessDetails?.vehicleDetails?.vehicleClassCode);
    this.motorService.vehicleClassShortDesc = businessDetails?.vehicleDetails?.vehicleClassShortDesc;
    this.motorService.productUin = businessDetails?.quoteDetails?.productUin || "";
    this.motorService.productTypeId = businessDetails?.quoteDetails?.productTypeId || '';
    this.motorService.customerType.next(businessDetails?.vehicleDetails?.customerType);
    this.motorService.customerTypeId.next(businessDetails?.vehicleDetails?.customerType === 'Corporate' ? CustomerType.CORPORATE : CustomerType.INDIVIDUAL);
    this.motorService.productName = businessDetails?.vehicleDetails?.vehicleType || '';
    this.motorService.productNameForDeviation = businessDetails?.quoteDetails?.productName || '';
    this.motorService.vehicleTypeSelectOnProductType = businessDetails?.vehicleDetails?.vehicleType;
    this.motorService.productTenure = {
      odTenure: businessDetails?.vehicleDetails?.odTenure,
      tpTenure: businessDetails?.vehicleDetails?.tpTenure,
    }
    this.motorService.businessForm.patchValue(proposalBuisnessType);
    this.motorService.vehicleClassDescription = businessDetails?.vehicleDetails?.vehicleClassDescription || '';
    this.motorService.vehicleSubClassCode = businessDetails?.vehicleDetails?.vehicleSubClassCode;
  }

  async patchBusinessDetailsForm(businessDetails: any, vehicleDetails: any, previousPolicyNumber: any) {
    const RTO_CODE = vehicleDetails.rtoCode + ' ' + vehicleDetails.registrationPlace + ' Zone ' + vehicleDetails.rtoZone;
    const registrationNo = vehicleDetails?.vehicleRegistrationNo || '';
    const formattedRegistrationNo = registrationNo.replace(/-/g, '');
    this.motorService?.businessForm.patchValue({
      chassisNo: vehicleDetails?.chassisNo,
      productType: businessDetails?.productType,
      rtoCode: RTO_CODE ? RTO_CODE : "",
      registrationNo: formattedRegistrationNo,
      productCode: vehicleDetails?.productCode,
      businessType: vehicleDetails?.businessType,
      customerType: vehicleDetails?.customerType,
      vehicleClass: vehicleDetails?.vehicleClass,
      vehicleSubClass: vehicleDetails?.vehicleSubClass,
      vehicleSegment: vehicleDetails?.vehicleSegment,
      vehicleClassDescription: vehicleDetails?.vehicleClassDescription || "",
      vehicleSubClassCode: vehicleDetails.vehicleSubClassCode || 0,
      policyNo: previousPolicyNumber
    });
    this.motorService.vehicleSegmentClass = vehicleDetails?.vehicleSubClassCode || 0;
    this.motorService.productName = vehicleDetails?.vehicleType;
    this.motorService.productNameForDeviation = businessDetails?.productName;
    this.motorService.vehicleClassForDeviation = vehicleDetails?.vehicleClass;
    this.motorService.vehicleTypeSelectOnProductType = vehicleDetails?.vehicleType;
    this.motorService.customerTypeId.next(vehicleDetails?.customerType === 'Corporate' ? CustomerType.CORPORATE : CustomerType.INDIVIDUAL);
    this.motorService.rtoCode = {
      "registrationZone": vehicleDetails?.rtoZone,
      "rtoLocationCode": vehicleDetails?.rtoCode,
      "rtoLocationName": vehicleDetails?.registrationPlace
    }
    this.motorService.productCode = businessDetails?.productCode || "";
    this.motorService.productUin = businessDetails?.productUin || "";
    this.motorService.gcProductCode = businessDetails?.gcProductCode || '';
    this.motorService.segment = vehicleDetails?.vehicleSegment || '';
    this.motorService.productTypeId = businessDetails?.productTypeId || '';
    this.motorService.vehicleClassCode = Number(vehicleDetails?.vehicleClassCode);
    this.motorService.vehicleClassDescription = vehicleDetails?.vehicleClassDescription || '';
    this.motorService.vehicleSubClassCode = vehicleDetails?.vehicleSubClassCode;
    this.motorService.commericalVehicleClassCode = vehicleDetails?.vehicleClassCode;
    this.motorService.vehicleClassShortDesc = vehicleDetails?.vehicleClassShortDesc;
    this.motorService.productTenure = {
      odTenure: vehicleDetails?.odTenure,
      tpTenure: vehicleDetails?.tpTenure,
    }

  }

  patchRiskForm(riskDetails: any): void {
    let odStartDate = this.motorService.normalizeDateToCustomISO(riskDetails?.odStartDate);
    let odEndDate = this.motorService.normalizeDateToCustomISO(riskDetails?.odEndDate);
    let tpStartDate = this.motorService.normalizeDateToCustomISO(riskDetails?.tpStartDate);
    let tpEndDate = this.motorService.normalizeDateToCustomISO(riskDetails?.tpEndDate);
    this.motorService.riskForm.patchValue({
      odTenure: this.motorService?.productTenure?.odTenure,
      tpTenure: this.motorService?.productTenure?.tpTenure,
      odStartDate: odStartDate || '',
      odEndDate: odEndDate || '',
      tpStartDate: tpStartDate || '',
      tpEndDate: tpEndDate || '',
    });
    if (this.motorService.isBusinessTypeUsed) {
      this.motorService.minUsedTypeDate = this.motorService.isLiability ? new Date(riskDetails?.tpStartDate) : new Date(riskDetails?.odStartDate);
      this.motorService.minUsedTypeDate.setDate(this.motorService.minUsedTypeDate.getDate() - (this.motorService.usedVehicleConfigureDay - 1));
      this.motorService.maxUsedTypeDate = this.motorService.isLiability ? new Date(riskDetails?.tpStartDate) : new Date(riskDetails?.odStartDate);
      this.motorService.maxUsedTypeDate.setDate(this.motorService.maxUsedTypeDate.getDate() + (this.motorService.usedVehicleConfigureDay - 1));
    }
  }

  patchPreviousPolicyForm(policyDetails: PreviousPolicyDetailsFromQuote, noPYP?: string, currentPolicyNCB?: string) {
    if (!policyDetails) return;
    if (policyDetails['transferofOwnership'] !== null && policyDetails['transferofOwnership'] !== undefined) {
      this.motorService.isTranferOfOwnerShipUpdating = true;
    }
    this.motorService.isClaimInLastYearUpdating = true;
    this.motorService?.previousPolicyForm?.patchValue({
      isClaimInLastYear: policyDetails?.isPreviousPolicyClaim,
      previousPolicyStartDate: policyDetails?.previousPolicyOdStartDate,
      // previousPolicyNCB: Number(policyDetails?.previousPolicyNcbPercentage),
      previousPolicyNCB: this.motorService.isLiability ? 0 : Number(policyDetails?.previousPolicyNcbPercentage),
      previousPolicyEndDate: this.motorService.normalizeDateToCustomISO(policyDetails?.previousPolicyOdEndDate),
      previousPolicyAavilable: noPYP !== 'Y' ? true : false,
      transferofOwnership: policyDetails['transferofOwnership'],
      previousPolicyNumber: policyDetails?.previousPolicyNumber,
      isNilDepOpted: policyDetails?.isNilDepOpted,
      isConsumableOpted: policyDetails?.isConsumableOpted,
      isGapValueOpted: policyDetails?.isGapValueOpted,
      isEngineSafeOpted: policyDetails?.isEngineSafeOpted,
      isLibertyBatterySecureOpted: policyDetails?.isLibertyBatterySecureOpted,
      isLibertyEvSecureOpted: policyDetails?.isLibertyEvSecureOpted,
      previousPolicyType: policyDetails?.previousPolicyProductType,
      previousYearPolicyInsurer: policyDetails?.previousPolicyInsurer,
      currentPolicyNCB: this.motorService?.isLiability ? 0 : currentPolicyNCB ? Number(currentPolicyNCB) : 0
    });
    this.motorService.previousPolicyTypeName = policyDetails?.prevPolicyType;
    this.motorService.gcReferenceno = policyDetails?.gcReferenceno;
    if (!this.motorService?.previousPolicyForm.value.previousPolicyAavilable) {
      this.motorService.previousPolicyForm?.controls.previousPolicyType?.clearValidators();
      this.motorService.previousPolicyForm?.controls.previousPolicyType?.updateValueAndValidity({ emitEvent: false });
      this.motorService.previousPolicyForm?.controls.previousPolicyNumber?.clearValidators();
      this.motorService.previousPolicyForm?.controls.previousPolicyNumber?.updateValueAndValidity({ emitEvent: false });
      this.motorService.previousPolicyForm?.controls.previousYearPolicyInsurer?.clearValidators();
      this.motorService.previousPolicyForm?.controls.previousYearPolicyInsurer?.updateValueAndValidity({ emitEvent: false });

    }
    this.motorService.claimCountInPreviousPolicy = policyDetails?.previousPolicyClaimCount;
    this.motorService.isClaimInLastYear = policyDetails?.isPreviousPolicyClaim;
  }

  async patchVehicalForm(vehicleData, dataFrom?: string, invoiceDate?: any, premiumDetails?: any) {
    const MASTER_DATA = vehicleData?.masterData && vehicleData?.masterData.length ? vehicleData?.masterData[0] : null;
    const currentMonth = vehicleData?.mfgMonth;
    const MFG_YR_STR = `${currentMonth}/${vehicleData?.mfgYear}`;
    const MFG_YR = moment(MFG_YR_STR, 'MM-YYYY').toISOString();
    if (!this.motorService.isBusinessTypeNew) {
      this.motorService.minInvoiceDate = moment(vehicleData?.registrationDate).startOf('month').toDate();
      this.motorService.maxInvoiceDate = moment().endOf('day').toDate();
      this.motorService.setRegStrationAndInvoiceDateCapping(vehicleData?.registrationDate, true);
    }
    // this.motorService.vehicleForm.controls.chassisIdv.patchValue(premiumDetails?.chassisIdv || 0);
    const SPLITTED_VEHICLE_REG_NO = this.splitVehicleRegistrationNo(vehicleData?.vehicleRegistrationNo, vehicleData?.rtoCode);
    this.motorService.isRegistrationNumber = vehicleData?.haveRegNumber;
    this.motorService.registrationDate = vehicleData?.registrationDate;
    this.motorService.manufactureYear = MFG_YR;
    this.motorService.vehicleForm.patchValue({
      make: dataFrom !== 'QuoteDetails' ? MASTER_DATA?.manufacturerProduct : vehicleData?.makeName || '',
      makeCode: dataFrom !== 'QuoteDetails' ? MASTER_DATA?.makeId : vehicleData?.makeCode || '',
      model: dataFrom !== 'QuoteDetails' ? MASTER_DATA?.vehicleModel : vehicleData?.modelName || '',
      modelCode: dataFrom !== 'QuoteDetails' ? MASTER_DATA?.modelId : vehicleData?.modelCode || '',
      variant: dataFrom !== 'QuoteDetails' ? MASTER_DATA?.variantName : vehicleData?.variantName || '',
      bodyType: dataFrom !== 'QuoteDetails' ? MASTER_DATA?.bodyType : vehicleData?.bodyType || '',
      grossVehicleWeight: dataFrom !== 'QuoteDetails' ? Number(vehicleData?.vehicleGrossWeight) || 0 : Number(vehicleData?.grossVehicleWeight) || 0,
      variantCode: dataFrom !== 'QuoteDetails' ? MASTER_DATA?.variantId : vehicleData?.variantCode || '',
      fuelType: dataFrom !== 'QuoteDetails' ? MASTER_DATA?.fuelType?.toUpperCase() || '' : vehicleData?.fuelType?.toUpperCase() || '',
      cubicCapacity: dataFrom !== 'QuoteDetails' ? MASTER_DATA?.cubicCapacity || '0' : vehicleData?.cubicCapacity || '0',
      seatingCapacity: dataFrom !== 'QuoteDetails' ? MASTER_DATA?.seatingCapacity || '0' : vehicleData?.seatingCapacity || '0',
      engineNumber: (dataFrom !== 'QuoteDetails' ? vehicleData?.rcEngineNumber || '' : vehicleData?.engineNumber || '').toUpperCase(),
      chassisNo: (dataFrom !== 'QuoteDetails' ? vehicleData?.rcChassisNumber || '' : vehicleData?.chassisNo || '').toUpperCase(),
      manufacturingYear: dataFrom !== 'QuoteDetails' ? vehicleData?.mfgYear : MFG_YR || '',
      registrationDate: this.motorService.normalizeDateToCustomISO(vehicleData?.registrationDate) || '',
      // invoiceDate: invoiceDate ? invoiceDate : this.motorService.normalizeDateToCustomISO(vehicleData?.registrationDate) || '',
      invoiceDate: invoiceDate || '',
      exShowroomPrice: dataFrom !== 'QuoteDetails' ? MASTER_DATA?.exShowroomPrice : vehicleData?.exshowroomPrice || 0,
      exShowroomPriceBody: (this.motorService.isMiscd || this.motorService.isCommercialVehicle) ? dataFrom !== 'QuoteDetails' ? Number(MASTER_DATA?.bodyPrice)
        : Number(vehicleData?.exShowroomPriceBody) || 0 : 0,
      exShowroomPriceChassis: (this.motorService.isMiscd || this.motorService.isCommercialVehicle) ? dataFrom !== 'QuoteDetails' ? Number(MASTER_DATA?.chassisPrice)
        : Number(vehicleData?.exShowroomPriceChassis) || 0 : 0,
      pinCode: vehicleData?.pinCode || '',
      vehicleRegistrationNo: this.motorService.isBusinessTypeNew ? '' : vehicleData?.vehicleRegistrationNo || '',
      vehicleAge: vehicleData?.vehicleAge || 0,
      bodyIdv: dataFrom !== 'QuoteDetails' ? vehicleData?.bodyIdv || 0 : this.motorService.isBusinessTypeRenew ? premiumDetails?.bodyIdv || 0 : vehicleData?.bodyidv || 0,
      chassisIdv: this.motorService.isBusinessTypeRenew && this.motorService.currentStep$.getValue() ? premiumDetails?.chassisIdv || 0 : vehicleData?.chassisIDv || vehicleData?.chassisidv || 0,
      kw: dataFrom !== 'QuoteDetails' ? MASTER_DATA?.kw !== 'null' ? Number(MASTER_DATA?.kw) : '' : Number(vehicleData?.kw) || '',
      // vehicleIdv : vehicleData?.vehicleIdv -- it is not in the response and is not required in the roll over before update quote
      registrationNumber1: SPLITTED_VEHICLE_REG_NO?.regNumber1 || vehicleData?.registrationNumber1,
      registrationNumber2: SPLITTED_VEHICLE_REG_NO?.regNumber2 || vehicleData?.registrationNumber2,
      registrationNumber3: SPLITTED_VEHICLE_REG_NO?.regNumber3 || vehicleData?.registrationNumber3,
      registrationNumber4: SPLITTED_VEHICLE_REG_NO?.regNumber4 || vehicleData?.registrationNumber4,
      bhSeriesChecked: SPLITTED_VEHICLE_REG_NO?.isBHSeriesChecked || vehicleData?.bhSeries,
      haveRegNumber: vehicleData?.haveRegNumber,
      noOfWheels: dataFrom !== 'QuoteDetails' ? Number(MASTER_DATA?.noOfWheels) || 0 : Number(vehicleData?.noOfWheels) || 0,
      usedDate: vehicleData?.rtoTransferDate ? PolicyConstant.rtoTransferDate : vehicleData?.salesDeedDate ? PolicyConstant.salesDeedDate : "",
      rtoTransferDate: vehicleData?.rtoTransferDate || '',
      salesDeedDate: vehicleData?.salesDeedDate || '',
    });
    if ((this.motorService.isBusinessTypeRollOver || this.motorService?.isBusinessTypeUsed) && this.motorService.IsFromInsight) {
      this.motorService.registrationDtaeValidation(this.motorService.registrationDate, this.motorService.manufactureYear);
    }
    if (this.motorService?.vehicleFormControls?.seatingCapacity?.value) {
      this.motorService.seatingCapacity = this.motorService?.vehicleFormControls?.seatingCapacity?.value;
    }
    if (this.motorService.currentStep$.getValue() && !this.motorService.isBusinessTypeRenew && this.motorService.isActiveTpPolicy) {
      this.motorService.setRegStrationAndInvoiceDateCapping(vehicleData?.registrationDate);
    }

    if (this.motorService.currentStep$.getValue() && vehicleData?.isVehicleDetailsMandatoryForSCPA !== null && vehicleData?.isVehicleDetailsMandatoryForSCPA !== undefined && vehicleData?.isVehicleDetailsMandatoryForSCPA !== 0) {
      this.motorService.isVehicleDetailsMandatoryForSCPA.patchValue(vehicleData?.isVehicleDetailsMandatoryForSCPA);
      if (this.motorService.isVehicleDetailsMandatoryForSCPA.value) {
        this.motorService.vehicleForm.controls.engineNumber.setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(30)]);
        this.motorService.vehicleForm.controls.chassisNo.setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(30)]);
        this.motorService.vehicleForm.controls.engineNumber.updateValueAndValidity({ emitEvent: false });
        this.motorService.vehicleForm.controls.chassisNo.updateValueAndValidity({ emitEvent: false });
      }
    }
    if (this.motorService.isActiveTpPolicy && this.motorService.currentStep$.getValue() && this.motorService.isBusinessTypeNew) {
      const SIX_MONTHS_AGO = moment().subtract(5, 'months');
      if (this.motorService.vehicleFormControls?.invoiceDate.value) {
        const MIN_START_DATE = moment(this.motorService.vehicleFormControls?.invoiceDate.value).startOf('day');
        if (MIN_START_DATE.isBefore(SIX_MONTHS_AGO)) {
          this.tpPolicyMinStartDate = SIX_MONTHS_AGO.toDate();
        } else {
          this.tpPolicyMinStartDate = MIN_START_DATE.toDate();
        }
      }
    }
    if (dataFrom === 'QuoteDetails') {
      this.motorService.currentChassisIdv = Number(this.motorService?.vehicleFormControls?.chassisIDv || 0);
    }
    if ((this.motorService.isMiscd || this.motorService.isCommercialVehicle) && !this.motorService.vehicleFormControls.variant.value) {
      this.motorService.vehicleForm.controls.variant.clearValidators();
      this.motorService.vehicleForm.controls.variant.updateValueAndValidity({ emitEvent: false });
    }
  }
  async policypatchVehicalForm(policyDetails: renewDetails) {
    const MASTER_DATA = policyDetails?.master && policyDetails?.master.length ? policyDetails?.master[0] : null;
    const MFG_YR_STR = `${policyDetails?.manufacturingmonth}/${policyDetails?.yom}`;
    const MFG_YR = moment(MFG_YR_STR, 'MM-YYYY').toISOString();
    const SPLITTED_VEHICLE_REG_NO = this.splitVehicleRegistrationNo(policyDetails?.regno);
    this.motorService.setRegStrationAndInvoiceDateCapping(policyDetails?.dateofregistration, true);
    if (MASTER_DATA) {
      const vehicleData = {
        make: MASTER_DATA?.manufacturerProduct,
        makeCode: MASTER_DATA?.makeId || "",
        model: MASTER_DATA?.vehicleModel || "",
        modelCode: MASTER_DATA?.modelId || "",
        variant: MASTER_DATA?.variantName || "",
        variantCode: MASTER_DATA?.variantId || "",
        bodyType: MASTER_DATA?.bodyType || '',
        fuelType: policyDetails?.fueltype.toUpperCase(),
        cubicCapacity: policyDetails?.cubiccapacity || 0,
        seatingCapacity: MASTER_DATA?.seatingCapacity || policyDetails?.seatingcapacity || 0,
        engineNumber: (policyDetails?.enginenumber || "").toUpperCase(),
        chassisNo: (policyDetails?.chassisnumber || '').toUpperCase(),
        grossVehicleWeight: Number(policyDetails?.gvw) || 0,
        manufacturingYear: MFG_YR,
        registrationDate: this.motorService.normalizeDateToCustomISO(policyDetails?.dateofregistration) || '',
        invoiceDate: this.motorService.normalizeDateToCustomISO(policyDetails?.dateofdelivery) || '',
        exShowroomPrice: policyDetails?.exshowroom || 0,
        exShowroomPriceBody: (this.motorService.isMiscd || this.motorService.isCommercialVehicle) ?
          Number(MASTER_DATA?.bodyPrice) || 0 : 0,
        exShowroomPriceChassis: (this.motorService.isMiscd || this.motorService.isCommercialVehicle) ? Number(MASTER_DATA?.chassisPrice) || 0 : 0,
        pinCode: policyDetails?.pincodehome,
        // vehicleIdv: policyDetails?.vehicleidv,
        // misc d
        vehicleIdv: this.motorService.isMiscd ? policyDetails?.vehicleidv : 0,
        bodyIdv: this.motorService.isMiscd ? policyDetails['body_idv'] : 0,
        chassisIdv: this.motorService.isMiscd ? policyDetails['chassisIdv'] : 0,
        vehicleRegistrationNo: policyDetails?.regno || '',
        registrationNumber1: SPLITTED_VEHICLE_REG_NO?.regNumber1,
        registrationNumber2: SPLITTED_VEHICLE_REG_NO?.regNumber2,
        registrationNumber3: SPLITTED_VEHICLE_REG_NO?.regNumber3,
        registrationNumber4: SPLITTED_VEHICLE_REG_NO?.regNumber4,
        bhSeriesChecked: SPLITTED_VEHICLE_REG_NO?.isBHSeriesChecked,
        kw: Number(MASTER_DATA?.kw) || '',
        noOfWheels: Number(MASTER_DATA?.noOfWheels) || 0
      };
      this.motorService.vehicleForm.patchValue(vehicleData);
      this.motorService.disableForm(this.motorService.vehicleForm);
      this.motorService.vehicleFormControls.vehicleIdv.enable();
      this.motorService.vehicleFormControls.chassisIdv.enable();
      this.motorService.vehicleFormControls.bodyIdv.enable();
    } else {
      console.warn('MASTER_DATA is null or empty, nothing to patch.');
    }
  }
  patchNomineeDetails(vehicleDetails: any): void {
    this.nomineeDetailForm.patchValue({
      nomineeName: vehicleDetails?.nomineeName,
      nomineeAge: vehicleDetails?.nomineeAge,
      nomineeRelationship: vehicleDetails?.nomineeRelationship,
      appointeeName: vehicleDetails?.appointeeName,
      appointeeAge: vehicleDetails?.appointeeAge,
      appointeeRelationship: vehicleDetails?.appointeeRelationship,
      minor: vehicleDetails?.isMinor,
    });
  }
  patchSMDetails(policyDetails: any, vehicleDetails?: any, isQuote?: boolean): void {
    if (!this.motorService?.smDetailForm) {
      this.motorService.smDetailForm = this.motorService.getSMForm();
    }
    this.motorService.smDetailForm?.patchValue({
      branchCode: policyDetails?.branchCode || "",
      intermediaryCode: policyDetails?.imdCode || "",
      smCode: isQuote ? policyDetails?.smCode : vehicleDetails?.smCode || "",
      smName: isQuote ? policyDetails?.smName : vehicleDetails?.smName || ""
    });
    if (policyDetails?.imdCode) {
      this.motorService.getEdmsDataForUser(policyDetails?.imdCode);
    }
  }

  patchFinancierDetails(vehicleDetails: any, isFromQuote?: boolean): void {
    if (!this.financierForm) {
      this.financierForm = this.getFinancierForm();
    }
    this.financierForm.patchValue({
      agreementType: isFromQuote ? vehicleDetails?.agreementType : vehicleDetails?.aggrementType,
      financierName: isFromQuote ? vehicleDetails?.financierBranch : vehicleDetails?.financierName,
      financierAddress: vehicleDetails?.financierAddress,
    });
  }
  patchPospDetails(vehicleDetails: any): void {
    if (!this.pospDetailForm) {
      this.pospDetailForm = this.getPospForm();
    }
    this.pospDetailForm.patchValue({
      pospName: vehicleDetails?.pospName,
      pospCode: vehicleDetails?.pospCode,
      pospPan: vehicleDetails?.pospPan,
      // pospAadhar: vehicleDetails?.
    });
  }
  patchActiveTpDetails(vehicleDetils): void {
    this.motorService.isActiveTpEditable = vehicleDetils?.isActiveTpEditable || false;
    if (!this.motorService.activeTpPolicyForm) {
      this.motorService.activeTpPolicyForm = this.motorService.getActiveTpPolicyForm();
    }
    // if (this.motorService.isBusinessTypeRollOver) {
    //   vehicleDetils.tpDocProof = "Previous Year policy";
    // }
    this.motorService.activeTpPolicyForm.patchValue({
      tpPolicyInsurer: vehicleDetils?.tpPolicyInsureName ? Number(vehicleDetils?.tpPolicyInsureName) : '',
      tpPolicyInsurerAdd: vehicleDetils?.tpPolicyInsureAddress,
      tpPolicyNo: vehicleDetils?.tpPolicyNumber,
      tpPolicyType: vehicleDetils?.tpPolicyType ? Number(vehicleDetils?.tpPolicyType) : '',
      tpPolicystartDate: vehicleDetils?.activeTpStartDate,
      tpPolicyEndDate: vehicleDetils?.activeTpEndDate,
      tpPolicyDocProof: vehicleDetils?.tpDocProof || '',
      tpPolicyTypeValue: vehicleDetils?.tpPolicyTypeValue,
      tpPolicyInsurerValue: vehicleDetils?.tpPolicyInsurerValue,
      anyTpClaimMade: vehicleDetils?.anyTpClaimMade ?
        typeof vehicleDetils?.anyTpClaimMade === 'string' ?
          JSON.parse(vehicleDetils?.anyTpClaimMade) :
          vehicleDetils?.anyTpClaimMade : false,
    });
    if (!this.motorService.isBusinessTypeNew && !this.motorService.activeTpPolicyForm.controls.tpPolicystartDate.value) {
      // this.motorService.activeTpPolicyForm.controls.tpPolicystartDate.patchValue(this.motorService.vehicleFormControls?.manufacturingYear?.value);
      this.motorService.activeTpPolicyForm.controls.tpPolicystartDate.patchValue('');
    }
    if (this.motorService.isBusinessTypeRenew && !this.motorService.isActiveTpEditable) {
      this.motorService.disableForm(this.motorService.activeTpPolicyForm);
    }
  }
  patchAdditionalAddonInfoForm(vehicleDetails): void {
    if (!this.additionalAddonInfoForm) {
      this.additionalAddonInfoForm = this.getAdditionalAddonInfoForm();
    }
    this.additionalAddonInfoForm.patchValue({
      tyreSerialNo1: vehicleDetails?.tyreSerialNo1 || '',
      tyreSerialNo2: vehicleDetails?.tyreSerialNo2 || '',
      tyreSerialNo3: vehicleDetails?.tyreSerialNo3 || '',
      tyreSerialNo4: vehicleDetails?.tyreSerialNo4 || '',
      tyreSerialNo5: vehicleDetails?.tyreSerialNo5 || '',
    });
  }
  splitVehicleRegistrationNo(vehicleRegistrationNo: string, rtoCode?: string): {
    regNumber1: string;
    regNumber2: string;
    regNumber3: string;
    regNumber4: string;
    regNumber: string;
    isBHSeriesChecked: boolean;
  } {
    let regNumber1 = '';
    let regNumber2 = '';
    let regNumber3 = '';
    let regNumber4 = '';
    let regNumber = '';
    let isBHSeriesChecked = false;
    if (vehicleRegistrationNo && vehicleRegistrationNo?.toLocaleLowerCase() === 'new') {
      if (this.motorService.currentStep$.getValue() && this.motorService.isBusinessTypeRenew) {
        this.motorService.isRegNoNewForRenew = true;
        const spiltRtoCode = rtoCode?.split('-');
        regNumber1 = spiltRtoCode?.length ? spiltRtoCode[0] : '';
        regNumber2 = spiltRtoCode?.length > 1 ? spiltRtoCode[1] : '';
        this.motorService.vehicleFormControls.registrationNumber1.setValidators([Validators.required]);
        this.motorService.vehicleFormControls.registrationNumber1.updateValueAndValidity({ emitEvent: false });
        this.motorService.vehicleFormControls.registrationNumber2.setValidators([Validators.required]);
        this.motorService.vehicleFormControls.registrationNumber2.updateValueAndValidity({ emitEvent: false });
        this.motorService.vehicleFormControls.registrationNumber3.setValidators([Validators.required]);
        this.motorService.vehicleFormControls.registrationNumber3.updateValueAndValidity({ emitEvent: false });
        this.motorService.vehicleFormControls.registrationNumber4.setValidators([Validators.required]);
        this.motorService.vehicleFormControls.registrationNumber4.updateValueAndValidity({ emitEvent: false });
      }
      return {
        regNumber1,
        regNumber2,
        regNumber3,
        regNumber4,
        regNumber,
        isBHSeriesChecked
      };
    }
    regNumber = this.motorService.isBusinessTypeNew ? '' : vehicleRegistrationNo || '',
      regNumber1 = regNumber.substring(0, 2);
    regNumber2 = regNumber.substring(2, 4);
    let vehicleCount = regNumber.length;
    // Logic for non-BH series registration numbers
    if (!regNumber2.toUpperCase().includes('BH')) {
      if (vehicleCount > 9) {
        if (vehicleCount === 11) {
          regNumber3 = regNumber.substring(4, 7); // Substring(4, 3)
          regNumber4 = regNumber.substring(7, 11); // Substring(7, 4)
        } else {
          regNumber3 = regNumber.substring(4, 6); // Substring(4, 2)
          regNumber4 = regNumber.substring(6, 10); // Substring(6, 4)
        }
      } else {
        if (vehicleCount === 8) {
          regNumber3 = regNumber.substring(3, 3); // Substring(3, 0)
          regNumber4 = regNumber.substring(4, 8); // Substring(4, 4)
        } else {
          regNumber3 = regNumber.substring(4, 5); // Substring(4, 1)
          regNumber4 = regNumber.substring(5, 9); // Substring(5, 4)
        }
      }
    }
    // Logic for BH series registration numbers
    else if (regNumber2.toUpperCase().includes('BH')) {
      isBHSeriesChecked = true;
      if (vehicleCount === 9) {
        regNumber3 = regNumber.substring(4, 8); // Substring(4, 4)
        regNumber4 = regNumber.substring(8, 9); // Substring(8, 1)
      } else if (vehicleCount === 10) {
        regNumber3 = regNumber.substring(4, 8); // Substring(4, 4)
        regNumber4 = regNumber.substring(8, 10); // Substring(8, 2)
      }
    }
    return {
      regNumber1,
      regNumber2,
      regNumber3,
      regNumber4,
      regNumber,
      isBHSeriesChecked,
    }
  }
  patchDiscountForm(premiumDetails: any, loadingOrDiscountPerc?): void {
    this.motorService.loadingOrDiscount = premiumDetails?.loadingOrDiscountPerc;
    // const thresholdLimit = this.motorService.isFromPricingDeviation ? this.motorService.approvedODDiscount : this.motorService.premiumBreakupData?.premiumDetails?.discount?.maxDiscount;
    //this.motorService.setMaxDiscountValidation(thresholdLimit);
    let proposalDiscountDetails = {
      loadingData: premiumDetails?.loadingOrDiscountPerc,
      volountryDeductible: premiumDetails?.volountryDeductible,
      antiTheftDevice: premiumDetails?.isAntitheftDevice,
      aaiMembership: premiumDetails?.isAaiMembership,
      vehicleForHandicap: premiumDetails?.isVehicleForHandicap,
      isTPPDiscountApplicable: premiumDetails?.isTPPD,
      voluntaryExcessAmount: Number(premiumDetails?.discVoluntary),
      isDiscountOrLoadingPer: loadingOrDiscountPerc ? loadingOrDiscountPerc : premiumDetails?.loadingOrDiscountPerc,
      loadingOrDiscount: premiumDetails?.loadingOrDiscount,
      isVintageCar: premiumDetails?.isVintageCar,
      isVoluntaryExcess: premiumDetails?.isDiscVoluntary,
      isDiscountForMotor: premiumDetails?.isDiscountMotorizedThreeWheeled,
      // isUseOfVehicleTown:premiumDetails?.isVintageCar,
      isVehicleConfinedToOwnPremises: premiumDetails?.isOwnPremises,
      isImt14: premiumDetails?.isImt14,
      // isSideCar: premiumDetails?.sideCar,
      // sideCar: premiumDetails?.sideCar,
      isSideCar: premiumDetails?.isSideCar,
      sideCar: premiumDetails?.isSideCar,
      isSideCarAmount: premiumDetails?.totalSideCarPremium || 0,
      sideCarDiscountAmt: premiumDetails?.totalDiscountAmount || 0,
      sideCarPrice: premiumDetails?.sideCarPrice || 0,
      // NCB Carry Forward Start
      ncbCarryForward: premiumDetails?.ncbCarryForward,
      ncbReservingLetter: premiumDetails?.ncbReservingLetter,
      ncbReservedValue: Number(premiumDetails?.ncbReservedValue),
      ncbReservingLetterExpiryDate: premiumDetails?.ncbReservingLetterExpiryDate,
      // NCB Carry Forward End

      // isSideCar:premiumDetails?.isVintageCar,
      // ncbCarryForward:premiumDetails?.isVintageCar,
      // ncbReservingLetter:premiumDetails?.isVintageCar,
      // ncbReservedValue:premiumDetails?.isVintageCar,
      // ncbReservingLetterExpiryDate:premiumDetails?.isVintageCar,
      nameOfAssociation: premiumDetails?.nameOfAssociation,
      membershipNo: premiumDetails?.membershipNo,
      membershipExpiryDate: premiumDetails?.membershipExpiryDate,
      automobileAssociationNo: premiumDetails?.automobileAssociationNo,
      ncbReservingPreviousClaim: premiumDetails?.ncbReservingPreviousClaim,
    }
    this.motorService.discountForm.patchValue(proposalDiscountDetails);
  }

  public proposalODCovers: any
  patchODCoverForm(premiumDetails: any): void {
    let geoGraphicalExtNames = [];
    if (premiumDetails?.geographicalAreaExtensionName && premiumDetails?.geographicalAreaExtensionName.length) {
      if (premiumDetails?.geographicalAreaExtensionName[0] === '') {
        premiumDetails?.geographicalAreaExtensionName?.shift();
      }
      geoGraphicalExtNames = premiumDetails?.geographicalAreaExtensionName.split(',');
    }
    if (premiumDetails.isGeographicalAllSelected) {
      geoGraphicalExtNames.push('SA');
    }
    if (premiumDetails?.isTrailerAttached) {
      this.motorService.trailerAttachedForm = this.motorService.getTrailerAttachedForm();
    } else {
      this.motorService.trailerAttachedForm = null;
    }
    this.proposalODCovers = {
      electricalAccessories: premiumDetails?.electricalIdv > 0,
      nonElectricalAccessories: premiumDetails?.nonElectricalIdv > 0,
      eleAccIDV: premiumDetails?.electricalAccPremium,
      nonEleAcceIDV: premiumDetails?.nonElectricalAccPremium,
      electricalAccessoriesIdv: premiumDetails?.electricalIdv,
      nonElectricalAccessoriesIdv: premiumDetails?.nonElectricalIdv,
      biofuelkit: premiumDetails?.isbiofuelKit || false,
      externalBifuelKitType: premiumDetails?.externalBifuelKitType || '',
      biFuelKitIDV: premiumDetails?.bifuelkitIdv,
      geographicalAreaExtensionName: geoGraphicalExtNames,
      electricalAccessoriesExshrowroomPrice: premiumDetails?.electricalIdv,
      nonElectricalAccessoriesExshrowroomPrice: premiumDetails?.nonElectricalIdv,
      biFuelKitInBuilt: premiumDetails?.isBifuelkit,
      externalBiFuelKitIExshowroomIdv: premiumDetails?.externalBiFuelKitIExshowroomIdv || 0,
      trailerIdv: premiumDetails?.trailerIdv,
      noOfTrailer: premiumDetails?.noOfTrailers || 0,
      isTrailerAttached: premiumDetails?.isTrailerAttached || false,
      trailerPrice: premiumDetails?.trailerPrice || '',
      externalBiFuelKit: premiumDetails?.isExternalBifuelKit || false,
      // externalBifuelKitType: premiumDetails?.externalBifuelKitType,
      externalBiFuelKitExshowroomPrice: premiumDetails?.externalBifuelKitPrice || '',
      // sidecaridv: new FormControl(0),//premiumDetails?
      isGeographicalAreaExtension: premiumDetails?.isGeographicalAreaExtension || false,
      // isDrivingTuition: premiumDetails?.isDrivingTuition,
      externalBiFuelKitManufactureName: premiumDetails?.externalBiFuelKitManufactureName,
      externalbiFuelKitModelNumber: premiumDetails?.externalbiFuelKitModelNumber,
      externalbiFuelKitIdentifactionNumber: premiumDetails?.externalbiFuelKitIdentifactionNumber,
      // externalBiFuelKitIExshowroomPrice: premiumDetails?.externalBiFuelKitIExshowroomPrice,
      isDrivingTuition: premiumDetails?.isDrivingTution || false,
      drivingLicenseId: premiumDetails?.drivingLicenseId,
      isImportedVehicle: premiumDetails?.isImportedVehicle || false,
      isExtensionofRallyCover: premiumDetails?.isExtensionForRallyCover || false,
      noOfDaysForExtensionOfRallyCover: premiumDetails?.noOfDaysRallyCover || 0,
      isVehicleUsedForRacingSpeedTestsDexterityTrialsHillClimbs: premiumDetails?.isExtensionForRacing || false,
      isImt23: premiumDetails?.isImt23 || false,
      isImt34: premiumDetails?.isImt34 || false,
      isImt47: premiumDetails?.isImt47 || false,
      isFibreGlass: premiumDetails?.isFiberGlassTank || false,
      trailerODRate: premiumDetails?.trailerODRate || null,
      trailerTPRate: premiumDetails?.trailerTPRate || null,
      payAsYouDriveFlag: premiumDetails?.payAsYouDriveFlag == 'Y' ? true : false,
      payAsYouDriveBasePlan: premiumDetails?.payAsYouDriveBasePlan,
      odoMeterReading: Number(premiumDetails?.odoMeterReading),
      ncbReferenceForLdGrid: Number(premiumDetails?.ncbReferenceForLdGrid),
      compareLdOnForgivenNcb: Number(premiumDetails?.compareLdOnForgivenNcb),
      ncbReferenceForAddonGrid: Number(premiumDetails?.ncbReferenceForAddonGrid),
      discountVariationODClaim: Number(premiumDetails?.discountVariationODClaim),
    }
    this.motorService.ODCoverForm.patchValue(this.proposalODCovers);
    if (!this.motorService.currentStep$.getValue()) {
      this.isTrailerAttached = premiumDetails?.isTrailerAttached || false;
    }
    if (this.motorService.currentStep$.getValue()) {
      this.motorService.electricalAccessoryTotal = Number(premiumDetails?.electricalIdv) || 0
      this.motorService.nonElectricalAccessoryTotal = Number(premiumDetails?.nonElectricalIdv) || 0
    }
  }

  public proposalTPCovers: any
  patchTPCoverForm(premiumDetails: any): void {
    this.proposalTPCovers = {
      paCoverOwnerDriver: premiumDetails?.isPaCoverOwnerDriver || false,
      paCoverOwnerDriverTenure: premiumDetails?.paCoverOwnerDriverTenure?.toString() === '0' ? '' : premiumDetails?.paCoverOwnerDriverTenure?.toString(),
      PACoverUnnamePass: premiumDetails?.paUnnamedCount,
      paCoverUnnamedPassengerValue: premiumDetails?.paUnnamedSI?.toString() === '0' ? '' : premiumDetails?.paUnnamedSI?.toString(),
      paCoverUnnamedPassenger: premiumDetails?.isPaCoverUnnamedPassenger || false,
      noOfUnNamedPass: premiumDetails?.noOfUnNamedPass,
      numberOfUnnamedPassenger: premiumDetails?.paUnnamedCount,
      paCoverNamedPassengerValue: premiumDetails?.paNamedPassengerSI?.toString() === '0' ? '' : premiumDetails?.paNamedPassengerSI?.toString(),
      paCoverNamedPassenger: premiumDetails?.isPaCoverNamedPassenger || false,
      numberOfNamedPassenger: Number(premiumDetails?.paNamedPassenger),
      numberofPaidDriver: premiumDetails?.paidDriverCount || 0,
      numberofPaidCleaner: premiumDetails?.paidCleanerCount || 0,
      numberofPaidConductor: premiumDetails?.paidConductorCount || 0,
      isPaCoverToPaidDriver: premiumDetails?.isPaCoverPaidDriver || false,
      paCoverPaidDriver: premiumDetails?.paPaidDriverSI?.toString() === '0' ? '' : premiumDetails?.paPaidDriverSI?.toString(),
      isLegalLiabilitytoPaidDriver: premiumDetails?.isLegalLiabilitytoPaidDriver || false,
      noOfPaidDriverForLegalLiability: premiumDetails?.noOfPaidDriverForLegalLiability || 0,
      noOfPaidCleanerForLegalLiability: premiumDetails?.noOfPaidCleanerForLegalLiability || 0,
      noOfPaidConductorForLegalLiability: premiumDetails?.noOfPaidConductorForLegalLiability || 0,
      isLegalLiabilitytoEmployees: premiumDetails?.isLegalLiabilitytoEmployees || false,
      numberofNonFarePayingPassenegers: parseInt(premiumDetails?.numberofNonFarePayingPassenegers, 10) || 0,
      isLegalLiabilityforNonFarePayingPassenger: premiumDetails?.isLegalLiabilityforNonFarePayingPassenger || false,
      isIndemnitytoHirer: premiumDetails?.isIndemnitytoHirer || false,
      numberofEmployees: Number(premiumDetails?.noOfEmployees) || '0',
      noOfSoldiersSailors: Number(premiumDetails?.noOfSoldiersSailors) || '0',
      tppd: premiumDetails?.isTPPD || false,
      isLegalLiabilitytoSoldiersSailorsAirmenEmployedAsDrivers: premiumDetails?.llToSoldierSailer || false,
      paCoverSIToOwnerDriver: premiumDetails?.paCoverSIToOwnerDriver?.toString(),
      commercialVehicleTpPremImt34: premiumDetails?.commercialVehicleTpPremImt34 || 0,
      totalDrivingTPPremium: premiumDetails?.totalDrivingTPPremium || 0,
      isLegalLiabilitytoPassengerExcludingEmployeesAmbulance: premiumDetails?.isLegalLiabilitytoPassengerExcludingEmployeesAmbulance || false,
      isLegalLiabilitytoPassengerExcludingEmployeesHearses: premiumDetails?.isLegalLiabilitytoPassengerExcludingEmployeesHearses || false,
      numberofPassengerExcludingEmployees: (premiumDetails?.numberofPassengerExcludingEmployees) || '',
    }
    if (!this.motorService.isPolicySODP && (this.motorService.isPrivateCar || this.motorService.isTwoWheeler || this.motorService.isMiscd || this.motorService.isCommercialVehicle)) {
      if (this.motorService.isCustomerIndividual) {
        this.motorService.TPCoverFormControls.ownerDriverDoesNotHoldAnEffectiveDrivingLicense.patchValue(premiumDetails?.ownerDriverDoesNotHoldAnEffectiveDrivingLicense);
        this.motorService.TPCoverFormControls.confirmOfHavingValidPersonalAccidentPolicy.patchValue(premiumDetails?.confirmOfHavingValidPersonalAccidentPolicy);
        // if (this.proposalTPCovers.paCoverOwnerDriver) {
        //   this.motorService.TPCoverFormControls.ownerDriverDoesNotHoldAnEffectiveDrivingLicense.patchValue(false);
        //   this.motorService.TPCoverFormControls.confirmOfHavingValidPersonalAccidentPolicy.patchValue(false);
        // } else {
        //   this.motorService.TPCoverFormControls.ownerDriverDoesNotHoldAnEffectiveDrivingLicense.patchValue(true);
        //   this.motorService.TPCoverFormControls.confirmOfHavingValidPersonalAccidentPolicy.patchValue(true);
        // }
      }
    }
    this.motorService.TPCoverForm.patchValue(this.proposalTPCovers);
    this.handleNomineeDetails();
  }
  public addOnsData: any
  patchCustomerData(): void {
    const MASTER_PINCODE = this.verifyCustomerKycData?.pinCodeMaster || null;
    this.pincodeDetails = this.verifyCustomerKycData?.pinCodeMaster || null;
    const salutation = this.verifyCustomerKycData?.Prefix?.split('')?.map((c, i) => {
      if (i !== 0) {
        return c.toLowerCase();
      } else {
        return c;
      }
    }).join('');
    let result = {
      proposerType: this.verifyCustomerKycData?.ProposerType || '',
      salutation: salutation || '',
      firstName: this.verifyCustomerKycData?.FirstName || '',
      middleName: this.verifyCustomerKycData?.MiddleName,
      lastName: this.verifyCustomerKycData?.LastName || '',
      companyName: this.verifyCustomerKycData?.CompanyName || '',
      gender: this.verifyCustomerKycData?.Gender || '',
      dob: this.verifyCustomerKycData?.DOB ? moment(this.verifyCustomerKycData?.DOB, 'MM/DD/YYYY').format(DateFormat.ISO_STRING) : '',
      doi: this.verifyCustomerKycData?.DOI,
      mobileNo: this.verifyCustomerKycData?.MobileNo || '',
      email: this.verifyCustomerKycData?.Email || '',
      proposerPAN: this.verifyCustomerKycData?.ProposerPAN || '',
      proposerAadhaarNumber: this.verifyCustomerKycData['ProposerAadhaarNumber'] || '',
      proposerCKYCNo: this.verifyCustomerKycData?.ProposerCKYC_No || '',
      city: MASTER_PINCODE?.cityDistrictName || '',
      pinCode: MASTER_PINCODE?.pinCode || '',
      state: MASTER_PINCODE?.stateName || '',
      mailingAreaOrLocality: MASTER_PINCODE?.cityDistrictName || '',
      mailingTownOrCity: MASTER_PINCODE?.cityDistrictName || '',
      mailingDistrictCd: MASTER_PINCODE?.cityDistrictCode || '',
      mailingStateCd: MASTER_PINCODE?.stateCode || '',
      mailingDistrict: MASTER_PINCODE?.cityDistrictName || '' || '',
      otherAddFLD1: this.verifyCustomerKycData?.Other_Add_FLD1,
      // otherAddFLD2: this.verifyCustomerKycData?.Other_Add_FLD2,
      otherAddFLD3: this.verifyCustomerKycData?.Other_Add_FLD3 || '',
      otherAddFLD4: this.verifyCustomerKycData?.Other_Add_FLD4 || '',
      otherAddFLD5: this.verifyCustomerKycData?.Other_Add_FLD5 || '',
      otherAddFLD6: this.verifyCustomerKycData?.Other_Add_FLD5 || '',
    }
    this.panNo = this.verifyCustomerKycData?.ProposerPAN || this.panNo;
    this.customerDetailsForm.patchValue(result);
  }
  patchCustomerDataForInsight(customerDetails: customerDetailsFromInsight, insightStatus?: string): void {
    let result = {
      proposerType: customerDetails?.customerType || '',
      isGstNumber: customerDetails?.isGstNumber || false,
      gstStateName: customerDetails?.gstStateName || '',
      gstinNumber: customerDetails?.gstinNumber || '',
      gstinNumber1: customerDetails.gstinNumber || '',
      gstinNumber2: customerDetails.gstinNumber2 || '',
      gstinNumber3: customerDetails.gstinNumber3 || '',
      salutation: customerDetails.insuredSalutation || '',
      firstName: customerDetails?.insuredFirstName || "",
      middleName: customerDetails?.insuredMiddleName || "",
      lastName: customerDetails?.insuredLastName || '',
      companyName: customerDetails?.insuredFirstName || '',
      gender: customerDetails?.insuredGender || '',
      dob: customerDetails?.insuredDob ? moment(customerDetails?.insuredDob, 'DD/MM/YYYY').format(DateFormat.ISO_STRING) : '',
      doi: customerDetails?.insuredDoi ? moment(customerDetails?.insuredDoi, 'DD/MM/YYYY').format(DateFormat.ISO_STRING) : '',
      mobileNo: customerDetails?.insuredPhoneNumber || '',
      email: customerDetails?.insuredEmailId || '',
      proposerPAN: customerDetails?.insuredPanNumber || '',
      proposerAadhaarNumber: customerDetails?.insuredAadharNumber || '',
      proposerCKYCNo: customerDetails?.insuredCkycNumber || '',
      city: customerDetails?.mailingAddressCity || '',
      pinCode: customerDetails?.permanentAddressPincode || '',
      state: customerDetails?.permanentAddressState || '',
      permanentAddress: customerDetails?.mailingAddress || '',
      permanentAddress2: customerDetails?.mailingAddress2 || '',
      permanentAddressPincode: customerDetails?.mailingAddressPinCode || '',
      permanentAddressState: customerDetails?.mailingAddressState || '',
      permanentAddressCity: customerDetails?.mailingAddressCity || '',
      mailingAreaOrLocality: customerDetails?.mailingAreaOrLocality || '',
      mailingTownOrCity: customerDetails?.mailingAreaOrLocality || '',
      mailingDistrictCd: customerDetails?.mailingDistrictCd || '',
      mailingStateCd: customerDetails?.mailingStateCd || '',
      mailingDistrict: customerDetails?.mailingDistrict || '',
      otherAddFLD1: customerDetails?.permanentAddress || '',
      otherAddFLD2: customerDetails?.permanentAddress2 || '',
      kycInitiatedBy: customerDetails?.kycInitiatedBy || '',

      // otherAddFLD2: customerDetails?.Other_Add_FLD2,
      // otherAddFLD3: customerDetails?.Other_Add_FLD3,
      // otherAddFLD4: customerDetails?.Other_Add_FLD4,
      // otherAddFLD5: customerDetails?.Other_Add_FLD5,
      // otherAddFLD6: customerDetails?.Other_Add_FLD5,
    }
    // if (!result?.selectedDocument) {
    //   if (customerDetails.insuredAadharNumber) {
    //     result.selectedDocument = 'proposerAadhaarNumber';
    //   } else if (customerDetails.insuredPanNumber) {
    //     result.selectedDocument = 'proposerPAN';
    //   } else if (customerDetails.insuredCkycNumber) {
    //     result.selectedDocument = 'proposerCKYCNo';
    //   } else {
    //     result.selectedDocument = 'proposerPAN';
    //   }
    // }
    if (!this.customerDetailsForm) {
      this.customerDetailsForm = this.getCustomerKYCDetailsForm();
    }
    this.panNo = customerDetails?.insuredPanNumber || this.panNo;
    this.customerDetailsForm.patchValue(result);
    // this.handleKycDocumentsValidation(result?.selectedDocument);
    this.customerDetailsForm?.controls?.state?.addValidators([Validators.required]);
    this.customerDetailsForm?.controls?.city?.addValidators([Validators.required]);
    this.customerDetailsForm?.controls?.pinCode?.addValidators([Validators.required]);
    this.customerDetailsForm?.controls?.otherAddFLD1?.addValidators([Validators.required]);
    this.customerDetailsForm?.controls?.mobileNo?.addValidators([Validators.required, Validators.pattern('^[6-9][0-9]{9}$'), Validators.maxLength(10)]);
    this.customerDetailsForm?.controls?.email?.addValidators([Validators.required]);
    this.customerDetailsForm?.controls?.permanentAddress?.addValidators([Validators.required]);
    // this.customerDetailsForm?.controls?.permanentAddress2?.addValidators([Validators.required]);
    this.customerDetailsForm?.controls?.permanentAddressPincode?.addValidators([Validators.required, Validators.pattern(/^[0-9]{6}$/)]);
    this.customerDetailsForm?.controls?.permanentAddressState?.addValidators([Validators.required]);
    this.customerDetailsForm?.controls?.permanentAddressCity?.addValidators([Validators.required]);
    if (this.motorService.isBusinessTypeRenew && insightStatus !== InsighStatus.PENDING_PAYMENT) {
      this.customerDetailsForm?.clearValidators();
      this.customerDetailsForm?.updateValueAndValidity({ emitEvent: false });
      this.customerDetailsForm?.disable();
      if (!this.customerDetailsFormControls?.permanentAddress?.value) {
        this.customerDetailsFormControls?.permanentAddress?.enable();
      }
      if (!this.customerDetailsFormControls?.permanentAddress2?.value) {
        this.customerDetailsFormControls?.permanentAddress2?.enable();
      }
      if (!this.customerDetailsFormControls?.permanentAddressPincode?.value) {
        this.customerDetailsFormControls?.permanentAddressPincode?.enable();
      }
      if (!this.customerDetailsFormControls?.permanentAddressState?.value) {
        this.customerDetailsFormControls?.permanentAddressState?.enable();
      }
      if (!this.customerDetailsFormControls?.permanentAddressCity?.value) {
        this.customerDetailsFormControls?.permanentAddressCity?.enable();
      }
    } else {
      if (insightStatus !== InsighStatus.PENDING_PAYMENT) {
        this.motorService.disableForm(this.customerDetailsForm);
      } else {
        this.customerDetailsForm?.disable();
      }
    }
    if (this.customerDetailsFormControls?.dob?.value && this.isDateYear_1930(moment(this.customerDetailsFormControls?.dob?.value))) {
      this.customerDetailsFormControls?.dob?.enable();
    }
    if (this.customerDetailsFormControls?.doi.value && this.isDateYear_1930(moment(this.customerDetailsFormControls?.doi?.value))) {
      this.customerDetailsFormControls?.doi?.enable();
    }
  }
  patchCustomerConsent(vehicleDetails) {
    if (!this.customerConsentForm) {
      this.customerConsentForm = this.getCustomerConsentForm();
    }
    this.customerConsentForm?.patchValue({
      agreeWithTermsAndCondition: vehicleDetails?.consentMode === ConsentMode?.Declaration,
      consentMode: vehicleDetails?.consentMode === ConsentMode.otpMotorSaveProposal ? ConsentMode.OTP : vehicleDetails?.consentMode || ConsentMode?.Signature,
      emailIndicator: false,//hardcode
      whatsAppIndicator: false,//hardcode
      partnerCopyIndicator: false,//hardcode
      paymentBehalfIndicator: false,//hardcode
      smsIndicator: false,//hardcode
      // endorsementNumber: '',
      // otp: '',
    });
  }
  get financierFormControl() {
    return this.financierForm.controls;
  }

  get nomineeDetailFormControl() {
    return this.nomineeDetailForm.controls;
  }

  get pospDetailFormControl() {
    return this.pospDetailForm.controls;
  }
  async createPremiumForProposal(payload?: any): Promise<boolean> {
    try {
      let smForm = this.motorService.smDetailForm.getRawValue();
      let userId = this.motorService.parentImdCode ? (this.motorService.showRPUUserData ? this.motorService.parentImdCode : this.commonService.getUserName()) : (this.motorService.smFormControls?.intermediaryCode?.value || this.commonService.getUserName());
      // let userId = this.motorService.parentImdCode ? this.commonService.getUserName() : smForm?.intermediaryCode || this.commonService.getUserName();
      const resQuote = await lastValueFrom(this.quoteService.agentDetail(userId));
      const resultProductCode = await lastValueFrom(this.quoteService.getUserDetail(userId, this.motorService.productCode));
      this.motorService.userDetails = resQuote;
      const userDetailByProductCode = resultProductCode.result;
      const PAYLOAD = this.motorService.getQuotePayload(QuoteRquestType.SAVE, userDetailByProductCode);
      PAYLOAD.motor.odCovers.noOfTrailer = PAYLOAD?.motor?.trailerObject?.length;

      PAYLOAD.quotationNo = this.motorService.quotationNumber;
      PAYLOAD.proposalNo = this.proposalNo || null;
      PAYLOAD.netPremium = "0";//hardcode
      PAYLOAD.premiumCalculated = this.isPremiumCalculated;
      PAYLOAD.motor.vehicleDetails.branchState = this.motorService?.edmsResponse?.branchOfficeState || "MAHARASHTRA";
      delete PAYLOAD.motor.otherAddOns;
      if (!this.additionalAddonInfoForm) {
        this.additionalAddonInfoForm = this.getAdditionalAddonInfoForm();
      }
      PAYLOAD.motor.additionalAddonInfomation = this.additionalAddonInfoForm.value;
      const res = await lastValueFrom(this.quoteService.draftProposalPayload(payload ? payload : PAYLOAD));
      if (res.status !== 200) {
        //console.log(res, 'From proposal Service');
        this.notificationService.showError(res.result, "Failed to get data!");
        return false;
      } else {
        this.proposalNo = res.result?.proposalNumber;
        this.isProposalOn = true;
        if (this.motorService.isVehicleDetailsMandatoryForSCPA.value) {
          this.motorService.vehicleForm.controls.engineNumber.setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(30)]);
          this.motorService.vehicleForm.controls.chassisNo.setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(30)]);
          this.motorService.vehicleForm.controls.engineNumber.updateValueAndValidity({ emitEvent: false });
          this.motorService.vehicleForm.controls.chassisNo.updateValueAndValidity({ emitEvent: false });
        }
        if (this.motorService.isGeographicalAllSelected) {
          const geographicalAreaExtensionName = this.motorService.ODCoverFormControls.geographicalAreaExtensionName.value;
          if (!geographicalAreaExtensionName.includes('SA')) {
            geographicalAreaExtensionName.push('SA');
            this.motorService.ODCoverFormControls.geographicalAreaExtensionName.patchValue(geographicalAreaExtensionName);
          }
        }
        if (this.motorService.isReferral) {
          const updatePayload = {
            "isReferral": this.motorService.isReferral,
            "currentStage": "CONVERTED_TO_PROPOSAL",
            "quotationNo": this.motorService.quotationNumber
          }

          await lastValueFrom(this.quoteService.updateStage(updatePayload));
          this.motorService.isReferral = false;
        }
        this.motorService.deviationDetails$.next({
          declineMake: ParamConsts.N,
          declineVariant: ParamConsts.N,
          declinedModel: ParamConsts.N,
          declineIDV: ParamConsts.N,
          declineVehicleAge: ParamConsts.N,
          declinedRto: ParamConsts.N
        });
        this.notificationService.showSuccess('Proposal Number ' + res.result?.proposalNumber + ' Generated Successfully!', "Success!");
        return true;
      }
    } catch (error) {
      //console.log(error);
      return false;
    }
  }
  async onSubmitSaveProposal(isFromSaveProposal?: boolean): Promise<boolean> {
    this.isSubmittedPoposal = true;
    let isActiveTpInvalid = false;
    if (!this.motorService.isActiveTpPolicy) {
      isActiveTpInvalid = false;
    } else {
      isActiveTpInvalid = this.motorService.activeTpPolicyForm.invalid;
    }
    let isTpCoverValid = true;
    if (this.motorService.isSCPA && this.motorService.TPCoverForm.invalid) {
      isTpCoverValid = false;
    }
    if (this.nomineeDetailForm.invalid || this.motorService.vehicleForm.invalid || this.motorService.discountForm.invalid || isActiveTpInvalid || this.motorService.ODCoverForm.invalid
      || this.motorService.TPCoverForm?.invalid || !isTpCoverValid || (this.motorService.isAdditionalAddonInfoOn && this.additionalAddonInfoForm.invalid)) {
      this.focusOnErrorFields();
      return false;
    }
    if (this.motorService.inspectionRequired) {
      // Object.keys(this.motorService.inspectionForm.controls).forEach(key => {
      //   const control = this.motorService.inspectionForm.get(key);
      //   //console.log(`${key} invalid:`, control.invalid, `touched:`, control.touched, `pristine:`, control.pristine);
      // });
      if (this.motorService.inspectionForm.invalid) {
        this.motorService.inspectionForm.markAllAsTouched();
        return false;
      }
      if (this.motorService.piPhotoValidation) {
        this.notificationService.showError('Please upload all files. All files are mandatory', '');
        return false;
      }
    }
    if (this.motorService.showVehicleIDV && (!this.motorService.isMiscd && !this.motorService.isCommercialVehicle)) {
      if (!this.checkIDVValidation()) { return false; }
    }

    if (!this.checkPricingValidation()) { return false; }
    if ((this.motorService.isMiscd || this.motorService.isCommercialVehicle) && !this.motorService.isLiability) {
      if (!this.motorService.checkBodyIdvValidation()) { return false; }
    }
    let smForm = this.motorService.smDetailForm.getRawValue();
    let userId = this.motorService.parentImdCode ? (this.motorService.showRPUUserData ? this.motorService.parentImdCode : this.commonService.getUserName()) : (this.motorService.smFormControls?.intermediaryCode?.value || this.commonService.getUserName());

    // let userId = this.motorService.parentImdCode ? this.commonService.getUserName() : smForm?.intermediaryCode || this.commonService.getUserName();
    const resQuote = await lastValueFrom(this.quoteService.agentDetail(userId));
    this.motorService.userDetails = resQuote;
    let payload = this.motorService.getQuotePayload(QuoteRquestType.SAVE);
    payload.motor.odCovers.noOfTrailer = payload?.motor?.trailerObject?.length;
    payload.premiumCalculated = this.isPremiumCalculated;
    payload.motor.nomineeDetails = this.nomineeDetailForm.value;
    payload.motor.financierDetails = this.financierForm.value;

    payload.motor.customerDetails.customerId = this.motorService.isBusinessTypeRenew ? this.motorService.customerId : '';
    payload.motor.pospDetails = {
      nameOfPosp: this.pospDetailForm.value?.pospName,
      pospCode: this.pospDetailForm.value?.pospCode,
      pospPan: this.pospDetailForm.value?.pospPan,
      pospAadhar: this.pospDetailForm.value?.pospAadhar
    }
    if (!this.additionalAddonInfoForm) {
      this.additionalAddonInfoForm = this.getAdditionalAddonInfoForm();
    }
    payload.motor.additionalAddonInfomation = this.additionalAddonInfoForm.value;
    payload.motor.tpCovers.basicTP = this.motorService.premiumBreakupData?.premiumDetails?.liability.basicTP;
    payload.motor.tpCovers.totalDrivingTPPremium = this.motorService.premiumBreakupData?.premiumDetails?.liability.totalDrivingTPPremium;
    payload.quotationNo = this.motorService.quotationNumber;
    payload.proposalNo = this.proposalNo;
    payload.netPremium = this.motorService.premiumBreakupData?.premiumDetails?.totalPremiumWithoutTax;
    payload.totalPremiumIncludingTax = this.motorService.premiumBreakupData?.premiumDetails?.totalPremiumIncludingTax;
    payload.igst = this.motorService?.premiumBreakupData?.premiumDetails?.taxAmount;
    payload.taxAmount = this.motorService?.premiumBreakupData?.premiumDetails?.taxAmount;
    payload.motor.odCovers.totalBasicODPrem = this.motorService.premiumBreakupData?.premiumDetails?.ownDamage?.totalBasicODPrem;
    payload.motor.odCovers.netOdPremium = this.motorService.premiumBreakupData?.premiumDetails?.ownDamage?.netOdPremium;
    payload.motor.odCovers.totalNetOdPremium = this.motorService.premiumBreakupData?.premiumDetails?.ownDamage?.totalNetOdPremium;
    payload.motor.odCovers.ncbPrem = this.motorService.premiumBreakupData?.premiumDetails?.ownDamage?.totalNcbPremium || 0;
    payload.motor.discount.totalDiscountAmount = this.motorService.premiumBreakupData?.premiumDetails?.discount?.ldPremiumYr1 || 0;
    payload.motor.vehicleDetails.branchState = this.motorService?.edmsResponse?.branchOfficeState || "MAHARASHTRA";
    delete payload.motor.otherAddOns;
    payload.motor.vehicleDetails.ncb = this.motorService.premiumBreakupData?.premiumDetails?.newNcbDiscount || 0;

    if (isFromSaveProposal) {
      payload.motor.inspectionDetails.isInspectionCompleted = true //hardcode
    }
    const response = await lastValueFrom(this.quoteService.draftProposalPayload(payload));
    if (response.status !== 200) {
      this.notificationService.showError(response.message, response.result);
      return false;
    } else {
      this.motorService.encodeProposalNo = response?.result?.encodeProposalNo;
      this.notificationService.showSuccess(`Proposal Number ${this.proposalNo} saved successfully!`, 'Success!');
      this.motorService.handlePanelState(PanelState.PROPOSAL_SAVED);
      return true;
    }
  }
  getCalculatePremiumPayload() {
    const riskDetails = this.motorService?.riskForm?.value;
    if (this.motorService.isBusinessTypeRollOver) {
      riskDetails.riskScore = this.motorService.isLengthNotZero(this.motorService?.riskScoreDetails) ? this.motorService?.riskScoreDetails[0]?.riskScore || "" : "";
      riskDetails.riskBand = this.motorService.isLengthNotZero(this.motorService?.riskScoreDetails) ? this.motorService?.riskScoreDetails[0]?.riskBand || "" : "";
    }
    let pypDetails = this.motorService?.previousPolicyForm?.getRawValue();
    if (!pypDetails.previousPolicyAavilable || this.motorService.isBusinessTypeUsed) {
      this.motorService.resetPreviousPolicyForm(pypDetails);
    }
    if (this.motorService.isBusinessTypeRenew) {
      this.motorService.setExpiringPolicyCovers(pypDetails);
      pypDetails = this.motorService.previousPolicyForm.getRawValue();
    }
    riskDetails.odStartDate = !this.motorService?.isLiability && riskDetails?.odStartDate
      ? this.motorService.formatToCustomISO(riskDetails.odStartDate) : '';
    riskDetails.odEndDate = !this.motorService?.isLiability && riskDetails?.odEndDate
      ? this.motorService.formatToCustomISO(riskDetails.odEndDate) : '';
    riskDetails.tpStartDate = !this.motorService?.isPolicySODP && riskDetails?.tpStartDate
      ? moment(riskDetails?.tpStartDate)?.isValid()
        ? this.motorService.formatToCustomISO(riskDetails.tpStartDate) : '' : '';
    riskDetails.tpEndDate = !this.motorService?.isPolicySODP && riskDetails?.tpEndDate
      ? moment(riskDetails?.tpEndDate)?.isValid()
        ? this.motorService.formatToCustomISO(riskDetails.tpEndDate) : '' : '';
    const vehicleDetails = this.motorService.vehicleForm.getRawValue();
    vehicleDetails.vehicleRegistrationNo = !this.motorService.isBusinessTypeNew ? this.motorService.businessForm?.value?.registrationNo ||
      vehicleDetails?.vehicleRegistrationNo : this.isProposalOn ? vehicleDetails?.vehicleRegistrationNo || BusinessType.NEW : BusinessType.NEW,
      vehicleDetails.invoiceDate = vehicleDetails?.invoiceDate ? this.motorService.formatToCustomISO(vehicleDetails?.invoiceDate) : '';
    vehicleDetails.licensedCarryingCapacity = vehicleDetails?.seatingCapacity ? vehicleDetails?.seatingCapacity - 1 : '';
    vehicleDetails.deliveryDate = vehicleDetails?.invoiceDate ? this.motorService.formatToCustomISO(vehicleDetails?.invoiceDate) : '';
    // vehicleDetails.mappingfuelType = this.motorService.isProceedSuccess$.getValue() ? this.motorService.fuelTypeFromVehicleDetails : vehicleDetails.fuelType;
    vehicleDetails.mappingfuelType = vehicleDetails.fuelType;
    // NCB Carry Forward Start
    //  if(this.motorService.isBusinessTypeNew){
    //   vehicleDetails.ncb = 0;
    //   }
    //   else{
    vehicleDetails.ncb = pypDetails?.previousPolicyAavilable ? pypDetails.isClaimInLastYear ? 0 : pypDetails.currentPolicyNCB || 0 : 0;
    // }
    // NCB Carry Forward End
    vehicleDetails.exShowroomPrice = vehicleDetails?.exShowroomPrice ? Number(vehicleDetails?.exShowroomPrice) : 0;
    if (vehicleDetails?.manufacturingYear && typeof vehicleDetails?.manufacturingYear !== 'number') {
      const MFG_YR = typeof vehicleDetails?.manufacturingYear === 'string' ?
        moment(vehicleDetails?.manufacturingYear)?.year() : vehicleDetails?.manufacturingYear?.year();
      const MFG_Mon = typeof vehicleDetails?.manufacturingYear === 'string' ?
        moment(vehicleDetails?.manufacturingYear)?.month() + 1 : vehicleDetails?.manufacturingYear?.month() + 1;
      vehicleDetails.manufacturingYear = MFG_YR;
      vehicleDetails.manufacturingMonth = MFG_Mon < 10 ? `0${MFG_Mon}` : `${MFG_Mon}`;
    }
    vehicleDetails.grossVehicleWeight = Number(vehicleDetails?.grossVehicleWeight) || 0;
    let regNumber1 = '', regNumber2 = '', regNumber3 = '', regNumber4 = '';
    if (vehicleDetails.registrationNumber1 && vehicleDetails.registrationNumber1 != null && vehicleDetails.registrationNumber1 != undefined) {
      regNumber1 = vehicleDetails.registrationNumber1.replace(/-/g, '').replace(/\s+/g, '').trim();
    }
    if (vehicleDetails.registrationNumber2 && vehicleDetails.registrationNumber2 != null && vehicleDetails.registrationNumber2 != undefined) {
      regNumber2 = vehicleDetails.registrationNumber2.replace(/-/g, '').replace(/\s+/g, '').trim();
    }
    if (vehicleDetails.registrationNumber3 && vehicleDetails.registrationNumber3 != null && vehicleDetails.registrationNumber3 != undefined) {
      regNumber3 = vehicleDetails.registrationNumber3.replace(/-/g, '').replace(/\s+/g, '').trim();
    }
    if (vehicleDetails.registrationNumber4 && vehicleDetails.registrationNumber4 != null && vehicleDetails.registrationNumber4 != undefined) {
      regNumber4 = vehicleDetails.registrationNumber4.replace(/-/g, '').replace(/\s+/g, '').trim();
    }
    vehicleDetails.vehicleRegistrationNo = this.isProposalOn ? regNumber1 + regNumber2 + regNumber3 + regNumber4 || BusinessType.NEW : BusinessType.NEW;
    this.motorService.businessForm?.patchValue({
      registrationNo: vehicleDetails.vehicleRegistrationNo
    });
    if (this.motorService.isMiscd) {
      vehicleDetails.exShowroomPriceBody = Number(vehicleDetails.exShowroomPriceBody) || 0;
      // if(!vehicleDetails.exShowroomPriceBody){
      // }
      if (!vehicleDetails.exShowroomPriceChassis) {
        vehicleDetails.exShowroomPriceChassis = Number(vehicleDetails.exShowroomPrice) || 0;
      }
    }
    if (this.motorService.isMiscd || this.motorService.isCommercialVehicle) {
      vehicleDetails.vehicleIdv = Number(parseInt(vehicleDetails?.chassisIdv, 10) || 0) + Number(parseInt(vehicleDetails?.bodyIdv, 10));
    }
    const discount = this.motorService.discountForm.getRawValue();
    const odCovers = this.motorService.ODCoverForm.getRawValue();
    odCovers.isGeographicalAllSelected = false;
    if (odCovers?.geographicalAreaExtensionName?.length) {
      // odCovers.geographicalAreaExtensionName = odCovers?.geographicalAreaExtensionName?.filter(g => g !== 'SA');
      odCovers.geographicalAreaExtensionName.forEach((ge, i) => {
        if (ge === 'SA') {
          odCovers.geographicalAreaExtensionName.splice(i, 1);
          odCovers.isGeographicalAllSelected = true;
        }
      });
    }
    if (!odCovers?.isTrailerAttached) {
      this.motorService.ODCoverForm?.controls?.trailerPrice?.patchValue(0);
    }
    odCovers.isGeographicalAreaExtension = !odCovers?.geographicalAreaExtensionName?.length ? false : true;
    odCovers.electricalMinIDV = this.motorService.premiumBreakupData?.premiumDetails?.ownDamage?.idvElectricalMin || 0;
    odCovers.electricalMaxIDV = this.motorService.premiumBreakupData?.premiumDetails?.ownDamage?.idvElectricalMax || 0;
    odCovers.nonElectricalMinIDV = this.motorService.premiumBreakupData?.premiumDetails?.ownDamage?.idvNonElectricalMin || 0;
    odCovers.nonElectricalMaxIDV = this.motorService.premiumBreakupData?.premiumDetails?.ownDamage?.idvNonElectricalMax || 0;
    odCovers.externalBiFuelKitIExshowroomPrice = odCovers.externalBiFuelKitExshowroomPrice;
    const tpCover = this.motorService?.TPCoverForm?.getRawValue();
    if (this.motorService.isMiscd || this.motorService.isCommercialVehicle) {
      if (!tpCover.numberofPaidDriver) tpCover.numberofPaidDriver = 0;
      if (!tpCover.numberofPaidCleaner) tpCover.numberofPaidCleaner = 0;
      if (!tpCover.numberofPaidConductor) tpCover.numberofPaidConductor = 0;
      if (!tpCover.noOfPaidDriverForLegalLiability) tpCover.noOfPaidDriverForLegalLiability = 0;
      if (!tpCover.noOfPaidCleanerForLegalLiability) tpCover.noOfPaidCleanerForLegalLiability = 0;
      if (!tpCover.noOfPaidConductorForLegalLiability) tpCover.noOfPaidConductorForLegalLiability = 0;
    }
    if (!this.motorService.activeTpPolicyForm) {
      this.motorService.activeTpPolicyForm = this.motorService.getActiveTpPolicyForm();
    }
    const activeTpPolicyDetails = this.motorService.activeTpPolicyForm?.getRawValue();
    // if(this.isBusinessTypeRenew && this.renewDetails.thirdGridDetails && this.renewDetails.thirdGridDetails?.length){
    //   activeTpPolicyDetails.tpPolicyInsurer = this.renewDetails.thirdGridDetails[0]?.tpinsurerName || '';
    //   activeTpPolicyDetails.tpPolicyInsurerAdd = this.renewDetails.thirdGridDetails[0]?.tpinsurerAddress||'';
    //   activeTpPolicyDetails.tpPolicyNo = this.renewDetails.thirdGridDetails[0]?.tppolicyNumber||'';
    //   activeTpPolicyDetails.tpPolicyType = this.renewDetails.thirdGridDetails[0]?.tppolicyType|| '';
    //   activeTpPolicyDetails.tpPolicystartDate = this.renewDetails.thirdGridDetails[0]?.tppolicyStartDate||'';
    //   activeTpPolicyDetails.tpPolicyEndDate = this.renewDetails.thirdGridDetails[0]?.tppolicyEndDate||'';
    //   activeTpPolicyDetails.tpPolicyDocProof = this.renewDetails.thirdGridDetails[0]?.tppolicyDocumentProof || '';
    //   // activeTpPolicyDetails.anyTpClaimMade = this.renewDetails.thirdGridDetails[0]?.clai
    //   // anyTpClaimMade: new FormControl(false,Validators.requiredTrue),
    // }
    activeTpPolicyDetails.tpPolicystartDate = this.motorService.normalizeDateToCustomISO(activeTpPolicyDetails?.tpPolicystartDate);
    activeTpPolicyDetails.tpPolicyEndDate = this.motorService.normalizeDateToCustomISO(activeTpPolicyDetails?.tpPolicyEndDate);
    this.getInspectionDetails();
    const inspectionDetails = this.inspectionForm.value;
    const nomineeDetails = this.nomineeDetailForm.value;
    const financierDetails = this.financierForm.value;
    const pospDetails = this.pospDetailForm.value;
    const SPLITTED_ZONE = this.motorService.rtoCode?.registrationZone?.split(' ');
    const RTO_ZONE = SPLITTED_ZONE?.length > 1 ? SPLITTED_ZONE[1] : this.motorService.rtoCode?.registrationZone;
    vehicleDetails.state = this.motorService.edmsResponse?.branchOfficeState || "MAHARASHTRA";
    // let productName =this.motorService.productData?.find(p=> p?.productId == this.motorService.productId)?.productName;
    let addOnCvrList = [];
    if (!this.motorService.isLiability) {
      addOnCvrList = this.motorService?.addonsDataForProposal && this.motorService?.addonsDataForProposal?.length &&
        this.motorService?.addonsDataForProposal[0]?.planName !== 'Basic Plan' ? JSON.parse(JSON.stringify(this.motorService?.addonsDataForProposal)) : [];
    } else {
      addOnCvrList = [];
    }
    let evSecureTxt = 'EV Secure -';
    let addonCoverValue = {
      keyLossSI: '',
      personalBelongingSI: '',
      towingExpensesSI: '',
      additionalTowingSI: '',
      damageToChargerSI: '',
      reInstallationCoverSI: '',
      damageToPropertySI: '',
      chargerLiablityProtectionSI: '',
      monthlyEMIAmount: '',
      gapValue1: '',
    }
    for (let addoncover of addOnCvrList) {
      let evSecureLessText = addoncover?.coverName?.includes(evSecureTxt) ? addoncover?.coverName?.replace(evSecureTxt, '').trim() : addoncover?.coverName;
      addoncover.coverName = evSecureLessText;
      switch (addoncover?.coverName) {
        case "Loss Of Personal Belonging":
          addonCoverValue.personalBelongingSI = addoncover?.addonCoverValue;
          break;
        case "Key Loss":
          addonCoverValue.keyLossSI = addoncover?.addonCoverValue;
          break;
        case "Towing Expneses":
          addonCoverValue.towingExpensesSI = addoncover?.addonCoverValue;
          break;
        case "Addditional Towing":
          addonCoverValue.additionalTowingSI = addoncover?.addonCoverValue;
          break;
        case "Damage To Charger":
          addonCoverValue.damageToChargerSI = addoncover?.addonCoverValue;
          break;
        case "Reinstallation Of Wall Mounted Charger":
          addonCoverValue.reInstallationCoverSI = addoncover?.addonCoverValue;
          break;
        case "Damage To Property":
          addonCoverValue.damageToPropertySI = addoncover?.addonCoverValue;
          break;
        case "Charger Liability Protection Cover":
          addonCoverValue.chargerLiablityProtectionSI = addoncover?.addonCoverValue;
          break;
        case "Monthly Emi Amount":
          addonCoverValue.monthlyEMIAmount = addoncover?.addonCoverValue;
          break;
        case "Gap Value 1":
          addonCoverValue.gapValue1 = addoncover?.addonCoverValue;
          break;
        default:
          break;
      }
    }
    if (this.motorService.isBusinessTypeRollOver) {
      this.motorService.expiringPolicyCovers = [];
      if (pypDetails?.isNilDepOpted) {
        this.motorService.expiringPolicyCovers.push(AddonCovers.DEPRICATION);
      }
      if (pypDetails?.isConsumableOpted) {
        this.motorService.expiringPolicyCovers.push(AddonCovers.CONSUMABLES);
      }
      if (pypDetails?.isGapValueOpted) {
        this.motorService.expiringPolicyCovers.push(AddonCovers.GAP_VALUE_1);
      }
      if (pypDetails?.isEngineSafeOpted) {
        this.motorService.expiringPolicyCovers.push(AddonCovers.ENGINE_SAFE);
      }
      if (pypDetails?.isLibertyBatterySecureOpted) {
        this.motorService.expiringPolicyCovers.push(AddonCovers.LIBERTY_BATTERY_SECURE);
      }
      if (pypDetails?.isLibertyEvSecureOpted) {
        this.motorService.expiringPolicyCovers.push(AddonCovers.DAMAGE_TO_CHARGER);
        this.motorService.expiringPolicyCovers.push(AddonCovers.REINSTALL_WALL_MOUNTED_CHARGER);
        this.motorService.expiringPolicyCovers.push(AddonCovers.DAMAGE_TO_PROPERTY);
        this.motorService.expiringPolicyCovers.push(AddonCovers.LIABILITY_PROTECTION_COVER_CHARGER);
      }
    }
    if (this.motorService.leadId) {
      this.motorService.inspectionForm?.patchValue({
        reportReferenceNumber: this.motorService.leadId,
      });
    }
    odCovers.payAsYouDriveFlag = odCovers?.payAsYouDriveFlag ? ParamConsts.Y : null;
    odCovers.odoMeterReading = Number(odCovers?.odoMeterReading);

    return {
      lob: "Motor",
      source: 'SPP',
      imdCode: this.motorService.parentImdCode || this.motorService?.smFormControls?.intermediaryCode?.value || this.commonService.getUserName(),//for sm login
      imdName: this.commonService.getNickName(),
      quoteReqDate: this.motorService.formatToCustomISO(new Date()),
      proposalReqDate: this.motorService.formatToCustomISO(new Date()),
      createdBy: this.commonService.getUserName(),
      machineIp: this.commonService.getMachineIP() || '192.168.1.1',//hardoded
      quotationNumber: this.motorService.quotationNumber,
      proposalNumber: this.proposalNo, // ha
      // requestType: 'QuickQuote',
      businessType: this.motorService.businessType.getValue() !== BusinessType.RENEW ? this.motorService.businessType.getValue() : this.motorService.businessType.getValue() + 'al',
      customerType: this.motorService.customerType.getValue(),
      motor: {
        productId: this.motorService.productId || "",
        productCode: this.motorService.productCode,
        gcProductCode: this.motorService.gcProductCode,
        productType: this.motorService?.businessForm?.value?.productType,
        rtoCode: this.motorService.rtoCode?.rtoLocationCode,
        rtoName: this.motorService.rtoCode?.rtoLocationName,
        productUin: this.motorService.productUin,
        rtoZone: RTO_ZONE,
        policyType: this.motorService.policyType.getValue() ? this.motorService.policyType.getValue() : PolicyType.PACKAGE,
        isBreakin: this.motorService.isBreakin ? 1 : 0,
        isDeviation: true,
        vehicleType: this.motorService.isCommercialVehicle ? this.motorService.vehicleTypeSelectOnProductType : this.motorService.productName,
        // comercial vehicle
        // vehicleSegment: this.motorService.isCommercialVehicle ? this.motorService?.businessForm?.value?.vehicleSegment : "",
        vehicleSegment: this?.motorService.businessForm?.value?.vehicleSegment || this.motorService.segment,
        // misc
        bhSeries: this.motorService.vehicleForm?.value?.bhSeriesChecked ? true : false,
        haveRegNumber: this.motorService.vehicleForm?.value?.haveRegNumber ? true : false,
        vehicleClass: this.motorService.isMiscd ? "D" : this.motorService.isCommercialVehicle ? this.motorService?.businessForm?.value?.vehicleClass : this.motorService.productName,
        vehicleSubClass: this.motorService?.businessForm?.value?.vehicleSubClass || '',
        vehicleClassShortDesc: '',
        riskDetails: riskDetails,
        activeTpPolicyDetails: {
          ...activeTpPolicyDetails,
          isActiveTpEditable: this.motorService.isActiveTpEditable
        },
        previousPolicyDetails: {
          previousPolicyTPTenure: "",
          previousPolicyNumber: this?.motorService.businessForm?.value?.policyNo || '',
          previousPolicyProductType: pypDetails?.previousPolicyType,
          previousPolicyInsurer: pypDetails?.previousYearPolicyInsurer,
          previousInsurerAddress: "",
          previousPolicyOdEndDate: this.motorService.normalizeDateToCustomISO(pypDetails?.previousPolicyEndDate as string | Date),
          previousPolicyTpStartDate: "",
          previousPolicyTpEndDate: "",
          pastPolicyDocumentProof: "",
          previousPolicyNcbPercentage: pypDetails?.previousPolicyNCB,
          previousPolicyTpTenure: "",
          // "previousPolicyNumber": "",
          previousProductType: pypDetails?.previousPolicyType,
          previousInsurerName: "",
          // "previousInsurerAddress": "",
          previousPolicyOdEffectiveDate: "",
          previousPolicyOdExpiryDate: "",
          previousPolicyTpEffectiveDate: "",
          previousPolicyTpExpiryDate: "",
          // "pastPolicyDocumentProof": "",
          // "isTransferCase": 0,
          prevPolicyNcbPer: pypDetails?.previousPolicyNCB,
          prevPolicyType: this.motorService.isBusinessTypeUsed ? null : (!pypDetails?.previousPolicyAavilable ? "package" : this.motorService.previousPolicyTypeName),
          isClaimInPreviousPolicy: !this.motorService.isBusinessTypeNew ? !pypDetails?.isClaimInLastYear ? 0 : 1 : !discount.ncbReservingLetter ? 0 : 1,
          prevPolicyEndDate: this.motorService.normalizeDateToCustomISO(pypDetails?.previousPolicyEndDate as string | Date) || '',
          noPYP: pypDetails?.previousPolicyAavilable ? ParamConsts.N : ParamConsts.Y,
          previousPolicyOdTenure: !this.motorService.isBusinessTypeNew ? "Single Year" : "",//hardcode
          previousPolicyODTenure: !this.motorService.isBusinessTypeNew ? "Single Year" : "",//"",
          previousPolicyOdStartDate: this.motorService.normalizeDateToCustomISO(pypDetails?.previousPolicyStartDate as string | Date),
          isTransferCase: pypDetails?.transferofOwnership,
          transferofOwnership: pypDetails?.transferofOwnership,
          isNilDepOpted: pypDetails?.isNilDepOpted,
          isConsumableOpted: pypDetails?.isConsumableOpted,
          isGapValueOpted: pypDetails?.isGapValueOpted,
          isEngineSafeOpted: pypDetails?.isEngineSafeOpted,
          prevPolicyNCBPer: pypDetails?.previousPolicyNCB,
          isLibertyBatterySecureOpted: pypDetails?.isLibertyBatterySecureOpted,
          isLibertyEvSecureOpted: pypDetails?.isLibertyEvSecureOpted,
          isPreviousPolicyClaim: pypDetails?.isClaimInLastYear,
          // "prevPolicyType": !pypDetails?.previousPolicyAavilable ? "package" : this.previousPolicyTypeName,
          claimCountInPreviousPolicy: this.motorService.claimCountInPreviousPolicy || 0,
          vehicleOwnerNumber: this.motorService.vehicleOwnerNumber,
          lossOrTheft: this.motorService.isLengthNotZero(this.motorService.claimDetails) ? this.motorService.claimDetails[0]?.booOdTotalLoss : '',
          prevYrLossOrTheft: this.motorService.isLengthNotZero(this.motorService.claimDetails) ? this.motorService.claimDetails[0]?.booTheft : '',
          claimNotFullySettled: this.motorService.isLengthNotZero(this.motorService.claimDetails) ? this.motorService.claimDetails[0]?.claimStatus : '',
          expiringPolicyCovers: this.motorService.isBusinessTypeRenew ? this.motorService.expiringPolicyCoversForRenewal?.filter(epc => epc !== '') || [] : this.motorService.expiringPolicyCovers?.filter(epc => epc !== '') || [],
          previousYearTpClaimCount: this.motorService?.prevClaimDetails?.tpClaimCountInPastYears || "",
          previousYearTpClaimAmount: this.motorService?.prevClaimDetails?.tpClaimAmountInPastYears || "",
          firstPreviousYearOdClaimCount: this.motorService?.prevClaimDetails?.claimCountFirstPrecedingYear || "",
          firstPreviousYearOdClaimAmount: this.motorService?.prevClaimDetails?.claimAmountFirstPrecedingYear || "",
          secondPreviousYearOdClaimCount: this.motorService?.prevClaimDetails?.claimCountSecondPrecedingYear || "",
          secondPreviousYearOdClaimAmount: this.motorService?.prevClaimDetails?.claimAmountSecondPrecedingYear || "",
          renewalVehicleIdvMin: this.motorService.renewalVehicle_IDV_MIN,
          renewalVehicleIdvMax: this.motorService.renewalVehicle_IDV_MAX,
          renewalDumpDiscount: this.motorService?.renewalDumpDiscount,
          renewal_Body_IDV_MIN: this.motorService.renewal_Body_IDV_MIN,
          renewal_Body_IDV_MAX: this.motorService.renewal_Body_IDV_MAX,
          renewal_Chassis_IDV_MIN: this.motorService.renewal_Chassis_IDV_MIN,
          renewal_Chassis_IDV_MAX: this.motorService.renewal_Chassis_IDV_MAX,
          // renewal_Trailer_IDV_MIN: this.motorService.renewal_Trailer_IDV_MIN,
          // renewal_Trailer_IDV_MAX: this.motorService.renewal_Trailer_IDV_MAX
          policyTransEndors: this.motorService.policyTransEndors,
          optimizedPricing: this.motorService.renewDetails?.optimizedPricing,
          exceptionPricing: this.motorService.renewDetails?.exceptionPricing,
          exceptionFlag: this.motorService.renewDetails?.exceptionFlag,
          pypShortPeriod: this.motorService.pypShortPeriod
        },

        inspectionDetails: {
          ...inspectionDetails,
          "isInspectionCompleted": this.isManualInspection ? true : this.motorService?.isInspectionRecomended ? true : (this.motorService?.inspectionFormControls.isInspectionDone.value === 1 ? true : this.motorService?.preInspectionDetail?.leadId ? true : false),
          // "inspectionType": this.motorService?.PurposeOfInspection || this.motorService?.preInspectionDetail?.inspectionType || "",
          // "inspectionReferenceNumber": this.motorService?.inspectionForm.controls.reportReferenceNumber.value?.trim() || this.motorService?.preInspectionDetail?.leadId || "",
          // "reportDate": this.motorService?.inspectionFormControls.reportDate.value?.trim() || this.motorService?.preInspectionDetail?.recommendedDate || "",
          // "inspectionDate": this.motorService?.convertDateFormat(this.motorService?.inspectionFormControls.intimationDate.value?.trim()) || this.motorService?.preInspectionDetail?.inspectionDate || "",
          // "inspectionTime": this.motorService?.inspectionFormControls.intimationTime.value || this.motorService?.preInspectionDetail?.inspectionTime || "",
          // "inspectionDoneBy": this.motorService?.inspectionFormControls.inspectionDoneBy.value?.trim() || this.motorService?.preInspectionDetail?.inspectionDoneBy || this.motorService?.inspectionTypeSelfOrAgency,
          // "reportStatus": this.motorService?.inspectionFormControls.reportStatus.value?.trim() || this.motorService?.preInspectionDetail?.leadStatus || "",
          // "inspectionMode": this.motorService?.inspectionMode || this.motorService?.preInspectionDetail?.inspectionMode || "",
          // "inspectionPartner": this.motorService?.inspectionFormControls.inspectionPartner.value || this.motorService?.preInspectionDetail?.inspectionPartner || "",
          // "currentYearNcbPerc": 0,
          // "intimatorName": this.motorService?.inspectionFormControls.intimatorName.value?.trim() || this.motorService?.preInspectionDetail?.intimatorName || "",
          // "intimatorContactNo": this.motorService?.inspectionFormControls.intimatorMobileNo.value?.trim() || this.motorService?.preInspectionDetail?.intimatorPhone || "",
          // "intimatorEmailId": this.motorService?.inspectionFormControls.intimatorEmailId.value?.trim() || this.motorService?.preInspectionDetail?.intimatorEmailId || "",
          // "appointmentDate": "",
          // "appointmentAddressLine1": this.motorService?.inspectionFormControls.addressLine1.value?.trim() || this.motorService?.preInspectionDetail?.vehicleInspectionLocationAddress || "",
          // "appointmentAddressLine2": this.motorService?.inspectionFormControls.addressLine2.value?.trim() || this.motorService?.preInspectionDetail?.vehicleInspectionLocationAddress1 || "",
          // "appointmentPinCode": this.motorService?.inspectionFormControls.pinCode.value?.trim() || this.motorService?.preInspectionDetail?.pincode || "",
          // "appointmentCity": this.motorService?.inspectionFormControls.city.value?.trim() || this.motorService?.preInspectionDetail?.city || "",
          // "appointmentState": this.motorService?.inspectionFormControls.state.value?.trim() || this.motorService?.preInspectionDetail?.state || ""
        },
        vehicleDetails: {
          ...vehicleDetails,
          claimCountAllowedForLibertyAssure: this.motorService.premiumBreakupData?.vehicleDetails?.claimCountAllowedForLibertyAssure || "",
          vehicleRegistrationNo: this.motorService.businessForm?.value?.registrationNo || vehicleDetails?.vehicleRegistrationNo || '',
          chassisIdv: vehicleDetails?.chassisIdv ? vehicleDetails?.chassisIdv : 0,
          isNcb: false,//hard
          registrationPlace: this.motorService.rtoCode?.rtoLocationName,
          // masterGvw:this.motorService.masterGVW || 0,
          // masterGVW:this.motorService.masterGVW || 0,
          rtoTransferDate: this.motorService.formatToCustomISO(vehicleDetails?.rtoTransferDate) || '',
          salesDeedDate: this.motorService.formatToCustomISO(vehicleDetails?.salesDeedDate) || '',
          masterGvw: this.motorService.isBusinessTypeRenew ? vehicleDetails.grossVehicleWeight : (this.motorService.masterGVW || 0),
          masterGVW: this.motorService.isBusinessTypeRenew ? vehicleDetails.grossVehicleWeight : (this.motorService.masterGVW || 0),
        },
        discount: {
          ...discount,
          loadingOrDiscount: false,
          isLoadingOrDiscount: false,
          voluntaryExcess: discount?.isVoluntaryExcess,
          damageToChargerDeductible: this.motorService.damageToChargerDeductible || 0,
          damageToPropertyDeductible: this.motorService.damageToPropertyDeductible || 0,
        },
        odCovers: {
          ...odCovers,
          electricalAccessoriesDescription: odCovers?.electricalAccessoriesDescription || "",
          electricalAccessoriesMake: odCovers?.electricalAccessoriesMake || "",
          electricalAccessoriesModel: odCovers?.electricalAccessoriesModel || "",
          electricalAccessoriesSerialNo: odCovers?.electricalAccessoriesSerialNo || "",
          nonElectricalAccessoriesDescription: odCovers?.nonElectricalAcc || "",
          nonElectricalAccessoriesMake: odCovers?.nonElectricalAccessoriesMake || "",
          nonElectricalAccessoriesModel: odCovers?.nonElectricalAccessoriesModel || "",
          nonElectricalAccessoriesSerialNo: odCovers?.nonElectricalAccessoriesSerialNo || "",
          previousYearBiFuelKitIdv: odCovers?.previousYearBiFuelKitIdv || 0,
          externalBiFuelKitManufacturer: odCovers?.externalBiFuelKitManufacturer || "",
          externalBiFuelKitModelNumber: odCovers?.externalBiFuelKitModelNumber || "",
          externalBiFuelKitIdentificationNumber: odCovers?.externalBiFuelKitIdentificationNumber || "",
          payAsYouDriveDiscount: this.motorService?.payAsYouDriveDiscount,
          totalPayAsYouDriveDiscount: this.motorService?.totalPayAsYouDriveDiscount,
          payAsYouDriveKilometer: this.motorService?.payAsYouDriveKilometer,
          payAsYouDriveDiscountYr1: this.motorService?.payAsYouDriveDiscountYr1,
          idvTrailerMax: this.motorService.idvTrailerMax,
          idvTrailerMin: this.motorService.idvTrailerMin,
          imt44PremiumOD: this.motorService.premiumBreakupData?.premiumDetails?.ownDamage?.isIndemnitytoHirerOD
        },
        payAsYouDriveDetails: this.motorService?.payAsYouDriveDetails,
        tpCovers: {
          ...tpCover,
          // "paCoverOwnerDriver": "200000",
          // "paCoverOwnerDriverTenure": "1",
          // "ownerDriverDoesNotHoldAnEffectiveDrivingLicense": false,
          // "confirmOfHavingValidPersonalAccidentPolicy": false,
          // "isPaCoverToPaidDriver": false,
          // "paCoverPaidDriver": "100000",
          // "numberOfPaidDriver": 1,
          // "paCoverUnnamedPassenger": false,
          // "paUnnamedSI": "0",
          // "numberOfUnnamedPassenger": 2,
          // "paCoverUnnamedPassengerValue": "5000",
          // "paCoverUnnamedPersonAndPillionPassengerImt18": "15000",
          // "numberOfUnnamedPersonAndPillionPassenger": 2,
          // "paCoverNamedPassenger": false,
          // "paCoverNamedPassengerValue": "10000",
          // "isLegalLiabilityToPaidDriver": true,
          // "noOfPaidDriverForLegalLiability": "",
          // "isLegalLiabilityToEmployees": false,
          // "numberOfEmployees": 0,
          // "isLegalLiabilityToPassengerExcludingEmployees": "",
          // "numberOfPassengerExcludingEmployees": "",
          // "isLegalLiabilityForNonFarePayingPassenger": true,
          // "numberOfNonFarePayingPassengers": 2,
          // "isLegalLiabilityForFarePayingPassenger": false,
          // "numberOfFarePayingPassengers": 0,
          // "isLegalLiabilityToSoldiersSailorsAirmenEmployedAsDrivers": false,
          // "numberOfSoldiersSailorsAirmenEmployedAsDrivers": 0,
          // "isIndemnityToHirer": "",
          // "isCpaWaiverReason1": "",
          // "isCpaWaiverReason2": "",
          // "paCoverToConductorsCleaners": "50000",
          // "numberOfConductorsCleaners": 0,p
          // "isLegalLiabilityToPassengerExcludingEmployeesHearses": true,
          // "numberOfPassengerExcludingEmployeesHearses": 3,
          // "isLegalLiabilityToPassengerExcludingEmployeesAmbulance": false,
          // "numberOfPassengerExcludingEmployeesAmbulance": 0,
          // "isLegalLiabilityOfCleanersConductors": false,
          // "numberOfCleanersAndConductors": 0,
          // "isLegalLiabilityForPassenger": true,
          // "numberOfPassengers": 3,
          // "isVehicleDesignedAsCommercialVehiclesAndUsedForCommercialAndPrivatePurpose": false,
          // "noOfTyres": 0,
          isIndemnitytoHirer: tpCover?.isIndemnitytoHirer,
          imt44PremiumTP: this.motorService.premiumBreakupData?.premiumDetails?.liability?.isIndemnitytoHirer,
        },
        "addOnDetails": {
          "isAddOns": "",
          "id": "",
          "od": "",
          "tp": "",
          "premium": "",
          "isSelected": "",
          "consumables": "",
          "passengerAssist": "",
          "depreciation": "",
          "premiumInclTax": "",
          "additionalTowingSi": "",
          "gapValueSi": addonCoverValue.gapValue1,
          "keyLossSi": addonCoverValue.keyLossSI || '',
          "evSecureSi": "",
          lossOfPersonalBelongingsSi: addonCoverValue.personalBelongingSI || '',
          personalBelongingSI: addonCoverValue?.personalBelongingSI || '',
          towingExpensesSI: addonCoverValue?.towingExpensesSI || '',
          additionalTowingSI: addonCoverValue?.additionalTowingSI || '',
          damageToChargerSI: addonCoverValue?.damageToChargerSI || '',
          reInstallationCoverSI: addonCoverValue?.reInstallationCoverSI || '',
          damageToPropertySI: addonCoverValue?.damageToPropertySI || '',
          chargerLiablityProtectionSI: addonCoverValue?.chargerLiablityProtectionSI || '',
          monthlyEMIAmount: addonCoverValue?.monthlyEMIAmount || '',
          "addOnRateFromBRMS": "",
          "addonCoverRqLst": addOnCvrList
        },
        "nomineeDetails": nomineeDetails,
        "financierDetails": financierDetails,
        pospDetails: {
          nameOfPosp: pospDetails?.pospName,
          pospCode: pospDetails?.pospCode,
          pospPan: pospDetails?.pospPan,
          pospAadhar: pospDetails?.pospAadhar
        },
        "customerDetails": {
          "insuredFirstName": "",
          "insuredMiddleName": "",
          "insuredLastName": "",
          "insuredGender": "",
          "insuredSalutation": "",
          "insuredDob": "",
          "insuredDoi": "",
          "insuredAadharNumber": "",
          "insuredPanNumber": "",
          "insuredCkycNumber": "",
          "insuredPhoneNumber": "",
          "insuredAlternatePhoneNumber": "",
          "insuredEmailId": "john.doe@example.com",
          "insuredAlternateEmailId": "john.doe@alternate.com",
          "isGstNumber": true,
          "gstStateName": "",
          "gstinNumber": "",
          "mailingAddress": "",
          "mailingAddressPinCode": "",
          "mailingAddressState": "",
          "mailingAddressCity": "",
          "permanentAddress": "",
          "permanentAddressPincode": "",
          "permanentAddressState": "",
          "permanentAddressCity": "",
          "mailingAddress2": "",
          ...this.motorService?.customerDetails
        },
        "customerConsent": {
          "consentMode": "",
          "otpCode": ""
        },
        "uploadDocument": {
          "documentCategory": "",
          "documentFileName": "",
          "uploadedDocumentName": "",
          "uploadedDocument": ""
        },
        "paymentDetails": {
          "paymentMode": "Credit Card",//hardcoded
          "paymentBy": "John Doe",
          "paymentDate": "",
          "amount": "",
          "instrumentNumber": "",
          "bankName": "Bank of Example",
          "branchName": "Delhi Branch",
          "fullName": "John Doe",
          "emailId": "john.doe@example.com",
          "mobileNo": "",
          "transactionNo": ""
        },
        "exccess": {
          "imposedExcessRate": 0
        },
        "policyDetails": {
          "insurancePeriod": ""
        },
        "renewal": {
          "currentIdvCng": 0,
          "currentIdvElectrical": 0,
          "currentIdvLpg": 0,
          "currentIdvNonElectrical": 0,
          "currentIdvTrailer": 0,
          "expiringIdvCng": 0,
          "expiringIdvLpg": 0,
          "expiringIdvSideCar": 0,
          "expiringIdvTrailer": 0,
          "pyldRate": 0
        },
        deviations: this.motorService.deviationForProposal,
      }
    }
  }
  public focusOnErrorFields(): void {
    try {
      this.nomineeDetailForm.markAllAsTouched();
      if (this.nomineeDetailForm?.invalid) {
        this.motorService.isNomineePanelOpen = true;
      }
      this.motorService.vehicleForm.markAllAsTouched();
      if (this.motorService.vehicleForm?.invalid) {
        this.motorService.isVehiclePanelOpen = true;
      }
      this.motorService?.riskForm?.markAllAsTouched();
      if (this.motorService?.riskForm?.invalid) {
        this.motorService.isRiskPanelOpen = true;
      }
      this.motorService?.businessForm?.markAllAsTouched();
      if (this.motorService?.businessForm?.invalid) {
        this.motorService.isBusinessPanelOpen = true;
      }
      this.motorService?.discountForm?.markAllAsTouched();
      if (this.motorService?.discountForm?.invalid) {
        this.motorService.isDiscountPanelOpen = true;
      }
      this.motorService?.ODCoverForm?.markAllAsTouched();
      if (this.motorService?.ODCoverForm?.invalid) {
        this.motorService.isOdcoverPanelOpen = true;
        if (!this.motorService.isExternalFuelInfoPanelOpen) {
          this.motorService.isExternalFuelInfoPanelOpen = true;
        }
      }
      this.motorService?.TPCoverForm?.markAllAsTouched();
      if (this.motorService?.TPCoverForm?.invalid) {
        this.motorService.isTpcoverPanelOpen = true;
      }
      if (this.motorService.isActiveTpPolicy) {
        this.motorService?.activeTpPolicyForm?.markAllAsTouched();
        if (this.motorService?.activeTpPolicyForm?.invalid) {
          this.motorService.isActiveTpPolicyPanelOpen = true;
        }
      }
      if (this.motorService.isAdditionalAddonInfoOn) {
        this.additionalAddonInfoForm?.markAllAsTouched();
        if (this.additionalAddonInfoForm?.invalid) {
          this.motorService.isAdditionalInfoPanelOpen = true;
        }
      }
      const firstInvalidControlsID = document.querySelector('mat-form-field.ng-invalid, .mat-mdc-form-field.ng-invalid');
      firstInvalidControlsID?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (error) {
      //console.log(error);
    }
  }
  public focusKycFieldsOnError(): void {
    try {
      this.customerDetailsForm.markAllAsTouched();
      if (this.isCustomerConsentSubmitted) {
        this.customerConsentForm.markAllAsTouched();
      }
      const firstInvalidControlsID = document.querySelector('mat-form-field.ng-invalid, .mat-mdc-form-field.ng-invalid');
      //console.log(firstInvalidControlsID);
      firstInvalidControlsID?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (error) {
      //console.log(error);
    }
  }
  getNameSurname(): {
    name: string;
    surname: string;
    middleName: string;
  } {
    if (!this.insuredname || this.motorService.isCustomerCorporate) {
      return {
        name: '',
        surname: '',
        middleName: ''
      }
    } else {
      let str = this.insuredname?.trim().split(' ').filter(x => x);
      let name = str?.length > 0 ? str[0] : '';
      let surname = str?.length === 2 ? str[1] : str?.length > 2 ? str.slice(2).join(' ') : '';
      let middleName = str?.length > 2 ? str[1] : '';
      return {
        name,
        middleName,
        surname,

      }
    }
  }
  async calculatePremium(): Promise<boolean> {
    try {
      this.isSubmittedPoposal = true;
      this.motorService.saveQuoteSubmitted = true;
      this.motorService.isODCoverFormSubmitted.next(true);
      this.motorService.isTpCoverFormSubmitted.next(true);
      let isActiveTpInvalid = false;
      const odCovers = this.motorService?.ODCoverForm?.getRawValue();
      const tpCovers = this.motorService?.TPCoverForm?.getRawValue();
      const vehicleDetails = this.motorService?.vehicleForm?.getRawValue();
      // let idvTrailerMax = this.motorService.isBusinessTypeRenew ? this.motorService.renewal_Trailer_IDV_MAX : this.motorService.premiumBreakupData?.premiumDetails?.ownDamage?.idvTrailerMax;
      if (!this.motorService.isActiveTpPolicy) {
        isActiveTpInvalid = false;
      } else {
        isActiveTpInvalid = this.motorService.activeTpPolicyForm.invalid;
      }
      let isTpCoverValid = true;
      if (this.motorService.isSCPA && this.motorService.TPCoverForm.invalid) {
        isTpCoverValid = false;
      }
      if (this.motorService.isImt13And14BothSelected()) {
        this.notificationService.showError('limited to own premises and Confined to sites can not be selected together. Kindly select only applicable discount', '')
        return false;
      }
      if (odCovers?.electricalAccessories && !this.motorService.isLengthNotZero(this.motorService.electricalAccessoryData)) {
        if (!this?.motorService?.isOdcoverPanelOpen) {
          this.motorService.isOdcoverPanelOpen = true;
        }
        this.notificationService.showError('Please enter electrical accessories detail!', '');
        const firstInvalidControlsID = document.querySelector('.addItemElectricalAcc');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      } else if (odCovers?.electricalAccessories && this.isValueNA(this.motorService.electricalAccessoryData)) {
        if (!this?.motorService?.isOdcoverPanelOpen) {
          this.motorService.isOdcoverPanelOpen = true;
        }
        this.notificationService.showError('Please enter electrical accessories detail!', '');
        const firstInvalidControlsID = document.querySelector('.addItemElectricalAcc');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      } else if (odCovers?.nonElectricalAccessories && !this.motorService.isLengthNotZero(this.motorService.nonElectricalAccessoryData)) {
        if (!this?.motorService?.isOdcoverPanelOpen) {
          this.motorService.isOdcoverPanelOpen = true;
        }
        this.notificationService.showError('Please enter non-electrical accessories detail!', '');
        const firstInvalidControlsID = document.querySelector('.addItemNonElectricalAcc');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      } else if (odCovers?.nonElectricalAccessories && this.isValueNA(this.motorService.nonElectricalAccessoryData)) {
        if (!this?.motorService?.isOdcoverPanelOpen) {
          this.motorService.isOdcoverPanelOpen = true;
        }
        this.notificationService.showError('Please enter non-electrical accessories detail!', '');
        const firstInvalidControlsID = document.querySelector('.addItemNonElectricalAcc');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      else if (odCovers?.electricalAccessories && (this.motorService.electricalAccessoryTotal > this.motorService.idvElectricalMax) && !this.motorService.isElectricalAccApproved) {
        if (!this?.motorService?.isOdcoverPanelOpen) {
          this.motorService.isOdcoverPanelOpen = true;
        }
        this.notificationService.showError(`Electrical Accessories amount is greater than the range set by Underwriter (${this.motorService.idvElectricalMax})`, '');
        const firstInvalidControlsID = document.querySelector('.addItemElectricalAcc');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      } else if (odCovers?.electricalAccessories && (this.motorService.electricalAccessoryTotal < this.motorService.idvElectricalMin) && !this.motorService.isElectricalAccApproved) {
        if (!this?.motorService?.isOdcoverPanelOpen) {
          this.motorService.isOdcoverPanelOpen = true;
        }
        this.notificationService.showError(`Electrical Accessories amount is less than the range set by Underwriter (${this.motorService.idvElectricalMin})`, '');
        const firstInvalidControlsID = document.querySelector('.addItemElectricalAcc');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      } else if (odCovers?.nonElectricalAccessories && this.motorService.nonElectricalAccessoryTotal > this.motorService.idvNonElectricalMax && !this.motorService.isNonElectricalAccApproved) {
        if (!this?.motorService?.isOdcoverPanelOpen) {
          this.motorService.isOdcoverPanelOpen = true;
        }
        this.notificationService.showError(`Non Electrical Accessories amount is greater than the range set by Underwriter (${this.motorService.idvNonElectricalMax})`, '');
        const firstInvalidControlsID = document.querySelector('.addItemNonElectricalAcc');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      } else if (odCovers?.nonElectricalAccessories && this.motorService.nonElectricalAccessoryTotal < this.motorService.idvNonElectricalMin && !this.motorService.isNonElectricalAccApproved) {

        if (!this?.motorService?.isOdcoverPanelOpen) {
          this.motorService.isOdcoverPanelOpen = true;
        }
        this.notificationService.showError(`Non Electrical Accessories amount is less than the range set by Underwriter (${this.motorService.idvNonElectricalMin})`, '');
        const firstInvalidControlsID = document.querySelector('.addItemNonElectricalAcc');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      } else if (this.isValueNA(this.motorService.electricalAccessoryData) && odCovers?.electricalAccessories) {
        this.notificationService.showError('Please enter correct Electrical Accessories Data!', '');
        const firstInvalidControlsID = document.querySelector('.addItemElectricalAcc');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      } else if (this.isValueNA(this.motorService.nonElectricalAccessoryData) && odCovers?.nonElectricalAccessories) {
        this.notificationService.showError('Please enter correct NonElectrical Accessories Data!', '');
        const firstInvalidControlsID = document.querySelector('.addItemNonElectricalAcc');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      } else if (this.isValueNA(this.motorService.trailerAttachedData) && odCovers?.isTrailerAttached) {
        if (!this?.motorService?.isOdcoverPanelOpen) {
          this.motorService.isOdcoverPanelOpen = true;
        }
        this.notificationService.showError('Please enter correct trailer attached detail!', '');
        const firstInvalidControlsID = document.querySelector('.addItemTrailerAttched');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      } else if (!this.motorService.trailerAttachedData?.length && odCovers?.isTrailerAttached) {
        if (!this?.motorService?.isOdcoverPanelOpen) {
          this.motorService.isOdcoverPanelOpen = true;
        }
        this.notificationService.showError('Please enter trailer attached detail!', '');
        const firstInvalidControlsID = document.querySelector('.addItemTrailerAttched');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      } else if (odCovers?.isTrailerAttached && ((this.motorService.trailerAttachedTotal > this.motorService.idvTrailerMax) || (this.motorService.ODCoverForm.value.trailerPrice > this.motorService.idvTrailerMax))) {
        if (!this?.motorService?.isOdcoverPanelOpen) {
          this.motorService.isOdcoverPanelOpen = true;
        }
        this.notificationService.showError('Trailer amount is greater than the range set by Underwriter.', '');
        const firstInvalidControlsID = document.querySelector('.addItemTrailerAttched');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      else if (odCovers?.isTrailerAttached && ((this.motorService.trailerAttachedTotal < this.motorService.idvTrailerMin) || (this.motorService.ODCoverForm.value.trailerPrice < this.motorService.idvTrailerMin))) {
        if (!this?.motorService?.isOdcoverPanelOpen) {
          this.motorService.isOdcoverPanelOpen = true;
        }
        this.notificationService.showError('Trailer amount is less than the range set by Underwriter.', '');
        const firstInvalidControlsID = document.querySelector('.addItemTrailerAttched');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }

      else if ((this.motorService.isMiscd || this.motorService.isCommercialVehicle) && (Number(vehicleDetails?.chassisIdv) > Number(this.motorService.chassisIdvHigherValue)) && !this.motorService.isChassisIdvApproved) {
        this.notificationService.showError(`chassis idv eneterd is greater than the range set by Underwriter (${this.motorService.chassisIdvHigherValue})`, '');
        const firstInvalidControlsID = document.querySelector('.chassisIdv');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      else if ((this.motorService.isMiscd || this.motorService.isCommercialVehicle) && (Number(vehicleDetails?.chassisIdv) < Number(this.motorService.chassisIdvLowerValue)) && !this.motorService.isChassisIdvApproved) {
        this.notificationService.showError(`chassis idv eneterd is less than the range set by Underwriter (${this.motorService.chassisIdvLowerValue})`, '');
        const firstInvalidControlsID = document.querySelector('.chassisIdv');
        firstInvalidControlsID.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      else if (!odCovers?.electricalAccessories || !odCovers?.electricalAccessoriesExshrowroomPrice) {
        this.motorService.ODCoverForm.controls.electricalAccessoriesExshrowroomPrice.patchValue(0);
      } else if (!odCovers?.nonElectricalAccessories || !odCovers?.nonElectricalAccessoriesExshrowroomPrice) {
        this.motorService.ODCoverForm.controls.nonElectricalAccessoriesExshrowroomPrice.patchValue(0);
      }
      if (odCovers?.externalBiFuelKit && !this.motorService.isLiability) {
        const price = Number(odCovers?.externalBiFuelKitExshowroomPrice);

        const outOfCNGRange = odCovers?.externalBifuelKitType === 'CNG' &&
          (price < this.motorService.idvCNGMin || price > this.motorService.idvCNGMax) && !this.motorService.isExternalBifuelKitApproved;

        const outOfLPGRange = odCovers?.externalBifuelKitType === 'LPG' &&
          (price < this.motorService.idvLPGMin || price > this.motorService.idvLPGMax) && !this.motorService.isExternalBifuelKitApproved;

        if (outOfCNGRange || outOfLPGRange) {
          this.notificationService.showError(`External Bi-fuel Kit is not in the range set by Underwriter`, '');
          return false;
        }
      }

      if (this.motorService.showVehicleIDV && (!this.motorService.isMiscd && !this.motorService.isCommercialVehicle)) {
        if (!this.checkIDVValidation()) { return false; }
      }
      if ((this.motorService.isMiscd || this.motorService.isCommercialVehicle) && !this.motorService.isLiability) {
        if (!this.motorService.checkBodyIdvValidation()) { return false; }
      }

      if ((this.motorService.isMiscd || this.motorService.isCommercialVehicle) && tpCovers?.isPaCoverToPaidDriver) {
        if (!this.motorService.checkPaidDriverCleanerConductorValidation()) return false;
      }
      if ((this.motorService.isMiscd || this.motorService.isCommercialVehicle) && tpCovers?.isLegalLiabilitytoPaidDriver) {
        if (!this.motorService.checkLLPaidDriverCleanerConductorValidation()) return false;
      }
      if (!this.checkPricingValidation()) { return false; }
      if (this.nomineeDetailForm?.invalid || this.motorService?.vehicleForm?.invalid || this.motorService?.discountForm?.invalid
        || this.motorService.ODCoverForm?.invalid || isActiveTpInvalid || this.motorService.TPCoverForm?.invalid || !isTpCoverValid || (this.motorService.isAdditionalAddonInfoOn && this.additionalAddonInfoForm.invalid)) {
        this.focusOnErrorFields();
        return false;
      } else {
        if (!this.motorService.isPolicySODP && (this.motorService.isPrivateCar || this.motorService.isTwoWheeler || this.motorService.isMiscd || this.motorService.isCommercialVehicle)) {
          if (this.motorService.isCustomerIndividual) {
            if (!tpCovers.paCoverOwnerDriver && !tpCovers.ownerDriverDoesNotHoldAnEffectiveDrivingLicense && !tpCovers.confirmOfHavingValidPersonalAccidentPolicy) {
              this.notificationService.showError('Please select at least one I hereby confirm having a valid personal accident policy for Sum Insured of minimum 15 Lakhs or The Owner Driver does not hold an effective driving license', '');
              return false;
            }
          }
        }
        this.motorService.isODCoverFormSubmitted.next(false);
        if (!this.motorService.TPCoverForm.invalid || this.motorService.TPCoverForm.value.paCoverPaidDriver === '0' || this.motorService.TPCoverForm.value.paCoverPaidDriver === 0) {
          this.motorService.isTpCoverFormSubmitted.next(false);
        }
        this.isSubmittedPoposal = false;
        this.motorService.saveQuoteSubmitted = false;
        let payload = this.getCalculatePremiumPayload();
        payload.motor.tpCovers.basicTP = this.motorService.premiumBreakupData?.premiumDetails?.liability.basicTP;
        payload.motor.tpCovers.totalDrivingTPPremium = this.motorService.premiumBreakupData?.premiumDetails?.liability.totalDrivingTPPremium;
        payload.motor.odCovers.noOfTrailer = this.motorService?.trailerAttachedData?.length;
        // ODTP chnages
        if (this.motorService.isBusinessTypeRollOver || this.motorService?.isBusinessTypeUsed) {
          const QUOTE_DETAILS = await this.motorService.getQuoteDetails();
          this.motorService.vehicleData = QUOTE_DETAILS?.vehicleDetailsProceed ? QUOTE_DETAILS?.vehicleDetailsProceed : null;
          this.motorService.sudarshanaResponseInsights = QUOTE_DETAILS?.vehicleDetailsProceed?.sudarshana;
          // if (QUOTE_DETAILS?.vehicleDetailsProceed && Object.keys(QUOTE_DETAILS.vehicleDetailsProceed).length > 0) {
          //   await this.motorService.validateVehicleData();
          // }
        }
        // ODTP chnages end
        const response = await lastValueFrom(this.quoteService.calculateProposalPremium(payload));//calculateProposalPremium
        if (response.status !== 200) {
          this.isPremiumCalculated = false;
          this.notificationService.showError(response.message, 'Failed');
          return false;
        } else {
          if (!response.result?.motor?.premiumDetails?.totalPremiumIncludingTax) {
            this.notificationService.showError(response?.result?.errors && response?.result?.errors?.length ? response?.result?.errors[0] : 'There is some issue while calculating the premium from BRMS, Please try again later', 'Failed to get data');
            return false;
          }
          this.motorService.handlePanelState(PanelState.PREMIUM_CALCULATED);
          this.isPremiumCalculated = true;
          this.motorService.calculatePremiumResponse = response;
          this.motorService.premiumBreakupData = response.result?.motor;
          // this.motorService.selectedAddon.totalNcbPremium=this.motorService.premiumBreakupData?.premiumDetails?.ownDamage?.totalNcbPremium;
          this.notificationService.showSuccess('Premium Fetched successfully!', 'Success!');
          this.motorService.loadingOrDiscount = this.motorService?.premiumBreakupData?.premiumDetails?.loadingOrDiscountPerc;
          return true;
        }
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }
  async getCustomerConsent(): Promise<boolean> {
    try {
      this.isCustomerConsentSubmitted = true;
      this.isCustomerKYCDetailsSubmitted = true;
      this.customerDetailsFormControls.gstinNumber.patchValue(
        this.customerDetailsFormControls.gstinNumber1.value || "" +
        this.customerDetailsFormControls.gstinNumber2.value || "" +
        this.customerDetailsFormControls.gstinNumber3.value || ""
      );
      if (this.customerDetailsForm.invalid || this.customerConsentForm.invalid) {
        this.focusKycFieldsOnError();
        return false;
      };
      // let customerDetails = this.customerDetailsForm.getRawValue();
      let customerDetails = this.customerDetailsForm?.getRawValue();
      let customerConsent = this.customerConsentForm?.getRawValue();
      const isCustomerUpdated = await this.customerUpdate();


      if (!isCustomerUpdated) return false;
      const PAYLOAD = {
        "customerId": "",
        "mobileNumber": customerDetails?.mobileNo,
        "salutation": customerDetails?.salutation,
        "customerFirstName": customerDetails?.firstName,
        "customerLastName": customerDetails?.lastName,
        "proposalNumber": this.proposalNo,
        "emailId": customerDetails?.email,
        "modeofOperation": customerConsent?.consentMode,
        "endorsementNumber": customerConsent?.endorsementNumber,
        "productId": this.motorService?.productCode,
        "productName": this.motorService.businessForm.controls.productType.value ? this.motorService.businessForm.controls.productType.value : this.motorService.businessDetail$.getValue()?.productType,
        "emailIndicator": customerConsent?.emailIndicator,
        "smsIndicator": customerConsent?.smsIndicator,
        "whatsappIndicator": customerConsent?.whatsAppIndicator || false,
        "partnerCopyIndicator": customerConsent?.partnerCopyIndicator,
        "paymentBehalfIndicator": customerConsent?.paymentBehalfIndicator,
        "panNumber": customerDetails?.ProposerPAN || customerDetails?.proposerPAN
      }
      if (customerConsent?.consentMode === ConsentMode.Declaration) {
        PAYLOAD.emailIndicator = false;
        PAYLOAD.whatsappIndicator = false;
        PAYLOAD.smsIndicator = false;
        PAYLOAD.partnerCopyIndicator = false;
        PAYLOAD.paymentBehalfIndicator = false;
      }
      else if (customerConsent?.consentMode === ConsentMode.Signature) {
        //await this.ValidationForSignature();
        PAYLOAD.emailIndicator = false;
        PAYLOAD.whatsappIndicator = false;
        PAYLOAD.smsIndicator = false;
        PAYLOAD.partnerCopyIndicator = false;
        PAYLOAD.paymentBehalfIndicator = false;
      }
      else if (customerConsent?.consentMode === ConsentMode.OTP) {
        PAYLOAD.modeofOperation = ConsentMode.otpMotorSaveProposal;
      }
      const res = await lastValueFrom(this.quoteService.getCustomerConsent(PAYLOAD));
      if (res.status !== 200) {
        this.notificationService.showError(res?.message, 'Failed to get Customer Consent!');
        return false;
      } else {
        this.motorService.disableForm(this.customerConsentForm);
        this.customerDetailsForm.disable();
        // this.motorService.disableForm(this.customerDetailsForm);

        this.notificationService.showSuccess(res?.message, 'Success!');
        this.isKYC_Complete = true;
        return true;
      }
    } catch (err) {
      console.error(err);
      return false;
    }
  }
  async getGatewayPayU(productInfo: any, agenId?: any, officeCode?: any, TRANSACTIONID?: any) {
    this.isPaymentSubmitted = true;
    if (this.paymentDetailsForm.invalid) return null;
    this.isPaymentSubmitted = false;
    if (!this.motorService.edmsResponse && productInfo !== PolicyConstant.motorEndorsement) {
      let userId = this.motorService.parentImdCode ? (this.motorService.showRPUUserData ? this.motorService.parentImdCode : agenId || this.commonService.getUserName()) : (this.motorService.smFormControls?.intermediaryCode?.value || agenId || this.commonService.getUserName());
      this.motorService.edmsResponse = await lastValueFrom(this.quoteService.agentDetail(userId));
    }
    const TRANSACTION_ID = await lastValueFrom(this.quoteService.getTransactionId());
    //console.log(TRANSACTION_ID, "TRANSACTION_ID");
    if (!TRANSACTION_ID) {
      this.notificationService.showError(TRANSACTION_ID, 'Failed to get transactionId!');
      return null;
    } else {
      let customerDetails: CustomerKYCDetails = this.customerDetailsForm.getRawValue();
      const PAYLOAD = {
        "paymentDetails": {
          "transactionId": productInfo === PolicyConstant.ADVANCE_PAYMENT_LINK_MOTOR ? TRANSACTIONID : TRANSACTION_ID,
          "amount": this.paymentDetailsForm.getRawValue()?.amount,
          "productInfo": productInfo,//hardcoded
          "activityName": productInfo,
          "firstName": customerDetails?.firstName,
          "emailAddress": customerDetails?.email,
          "phoneNumber": customerDetails?.mobileNo,
          "agentId": this.motorService.parentImdCode || agenId || this.commonService.getUserName(),
          "officeCode": officeCode || this.motorService?.edmsResponse?.branchOfficeCode || this.commonService?.getOfficeCode() || '',
          "proposalNoList": [
            this.proposalNo
          ],
          // "panNumber": this.paymentDetailsForm.controls.panNo?.value || '',
          // "paymentBy":this.paymentDetailsForm.controls.paymentBy?.value?.toUpperCase(),
        }
      }
      if (productInfo === PolicyConstant.ADVANCE_PAYMENT_LINK_MOTOR) {
        delete PAYLOAD.paymentDetails.proposalNoList;
        PAYLOAD.paymentDetails.activityName = PolicyConstant.ADVANCE_PAYMENT_LINK_MOTOR;
      }
      if (productInfo === PolicyConstant.motorEndorsement) {
        PAYLOAD.paymentDetails['paymentBy'] = this.paymentDetailsForm.controls.paymentBy?.value?.toUpperCase();
      }

      const res = await lastValueFrom(this.quoteService.gatewayPayU(PAYLOAD));
      if (!res) {
        this.notificationService.showError('Failed to get Payment Window!', 'Failed!');
        return null;
      }
      else if (res?.error) {
        this.notificationService.showError(res?.error?.errorMessage, 'Failed!');
      }
      else {
        return res;
      }
    }
  }
  async getKycGateway(): Promise<string> {
    this.isCustomerKYCDetailsSubmitted = true;
    if (this.customerDetailsForm?.invalid) {
      this.focusKycFieldsOnError();
      return null;
    }
    const date = this.motorService.isCustomerCorporate ? this.customerDetailsFormControls?.doi?.value : this.customerDetailsFormControls?.dob?.value;
    const PAYLOAD = {
      "customerType": this.motorService.isCustomerCorporate ? (ParamConsts.C as string)?.toLowerCase() : (ParamConsts.I as string)?.toLowerCase(),
      "dob": date ? moment(date).format('DD/MM/YYYY') : date,//please do not change the MM/DD/YYYY format or else verification will fail and or fraud will trigger
      "mobile": this.motorService.isCustomerCorporate ? "" : this.customerDetailsForm?.controls?.mobileNo?.value || "",
      "proposalNumber": this.proposalNo || "", //mandatory only incase of proposal
      "quotationNumber": this.motorService.quotationNumber || "",
      "endorsementNumber": "", //mandatory only incase of endorsement
      "pan": "",
      "leadId": this.motorService.leadId || "",
      source: 'SPP',
      kycInitiatedBy: this.kycInitiatedBy,
    }
    const res = await lastValueFrom(this.quoteService.getKycGateway(PAYLOAD));
    if (res?.status !== 200) {
      this.notificationService.showError(res?.message, 'Failed!');
      return null;
    } else {
      this.isCustomerKYCDetailsSubmitted = false;
      return res?.result;
    }
  }
  async customerUpdate() {
    let customerDetails: CustomerKYCDetails = this.customerDetailsForm.getRawValue();
    this.panNo = customerDetails?.proposerPAN;
    const dob = customerDetails?.dob;
    const doi = customerDetails?.doi;
    const PAYLOAD = {
      proposalNo: this.proposalNo || null,
      insuredFirstName: this.motorService.isCustomerIndividual ? customerDetails?.firstName : customerDetails?.companyName,
      insuredMiddleName: this.motorService.isCustomerIndividual ? customerDetails?.middleName || null : null,
      insuredLastName: this.motorService.isCustomerIndividual ? customerDetails?.lastName || null : null,
      insuredGender: customerDetails?.gender || (this.motorService.isCustomerCorporate ? '' : 'M'),
      insuredCompanyName: customerDetails?.companyName || null,
      userId: this.motorService.parentImdCode || this.motorService?.smFormControls?.intermediaryCode?.value || this.commonService.getUserName() || null,
      insuredSalutation: customerDetails?.salutation || null,
      insuredDob: dob ? moment(dob).format('DD/MM/YYYY') : '',
      createdDate: moment().format(DateFormat.ISO_STRING) || null,
      createdBy: this.commonService.getUserName() || null,
      customerType: this.motorService?.isCustomerCorporate ? ParamConsts.C : ParamConsts.I,
      machineIp: this.commonService.getMachineIP() || null,
      insuredDOI: doi ? moment(doi).format('DD/MM/YYYY') : '',
      insuredAadharNumber: customerDetails?.proposerAadhaarNumber || null,
      insuredPanNumber: customerDetails?.proposerPAN || null,
      insuredCKYCNumber: customerDetails?.proposerCKYCNo || null,
      insuredPhoneNumber: customerDetails?.mobileNo || null,
      insuredAlternatePhoneNumber: "",//hardcode
      insuredEmailId: customerDetails?.email || null,
      insuredAlternateEmailId: "",//hardcode
      // selectedDocument: this.customerDetailsFormControls.selectedDocument.value || null,
      isGstNumber: this.customerDetailsFormControls.isGstNumber.value || null,
      gstStateName: this.customerDetailsFormControls.gstStateName.value || null,
      gstinNumber: this.customerDetailsFormControls.gstinNumber.value || null,
      gstinNumber1: this.customerDetailsFormControls.gstinNumber1.value || null,
      gstinNumber2: this.customerDetailsFormControls.gstinNumber2.value || null,
      gstinNumber3: this.customerDetailsFormControls.gstinNumber3.value || null,
      permanentAddress: customerDetails?.otherAddFLD1 || null,
      permanentAddress2: customerDetails?.otherAddFLD2 || null,
      permanentAddressPincode: customerDetails?.pinCode || null,
      permanentAddressState: customerDetails?.state || null,
      permanentAddressCity: customerDetails?.city || null,
      mailingAddress: this.customerDetailsFormControls?.permanentAddress.value || null,
      mailingAddressPinCode: this.customerDetailsFormControls.permanentAddressPincode.value || null,//customerDetails?.permanentAddressPincode,
      mailingAddressState: this.customerDetailsFormControls.permanentAddressState.value || null, //customerDetails?.state,
      mailingAddressCity: this.customerDetailsFormControls.permanentAddressCity.value || null, //customerDetails?.city,
      mailingAddress2: this.customerDetailsFormControls?.permanentAddress2.value || null,
      mailingAreaOrLocality: customerDetails?.mailingAreaOrLocality || null,
      mailingTownOrCity: customerDetails?.mailingTownOrCity || null,
      mailingDistrictCd: customerDetails?.mailingDistrictCd || null,
      mailingStateCd: customerDetails?.mailingStateCd || null,
      mailingDistrict: customerDetails?.mailingDistrict || null,
    }
    const RES = await lastValueFrom(this.quoteService.customerUpdate(PAYLOAD));
    if (RES.status !== 200) {
      this.notificationService.showError(RES?.message, '');
      return false;
    } else {
      // if (!this.motorService.isBusinessTypeRenew) {
      //   this.notificationService.showSuccess(RES?.message, '');
      // }
      return true;
    }
  }
  async raiseInspection(): Promise<boolean> {
    // Object.keys(this.motorService.inspectionForm.controls).forEach(key => {
    //   const control = this.motorService.inspectionForm.get(key);
    //   //console.log(`${key} invalid:`, control.invalid, `touched:`, control.touched, `pristine:`, control.pristine);
    // });
    if (this.motorService.isTwoWheeler || this.motorService.isCommercialVehicle || this.motorService.isMiscd) {
      if (this.motorService.isTWMandatoryDocUploaded) {
        this.motorService.piPhotoValidation = true;
      }
      else {
        this.motorService.piPhotoValidation = false;
      }
    }

    if (this.motorService.inspectionForm.valid) {
      if (!this.motorService.piPhotoValidation) {
        if (!this.motorService.isRecommended && this.motorService.inspectionForm.controls.reportStatus.value !== "" && this.motorService.inspectionForm.controls.isInspectionDone.value === 1) {
          this.notificationService.showError(`Approval is pending, please try again after some times.`, 'Error!');
          return false;
        }
        try {
          const vehicleDetails = this.motorService?.vehicleForm.getRawValue();
          if (vehicleDetails?.manufacturingYear && typeof vehicleDetails?.manufacturingYear !== 'number') {
            const MFG_YR = typeof vehicleDetails?.manufacturingYear === 'string' ?
              moment(vehicleDetails?.manufacturingYear)?.year() : vehicleDetails?.manufacturingYear?.year();
            vehicleDetails.manufacturingYear = MFG_YR;
          }
          if (((this.motorService.isMiscd || this.motorService.isCommercialVehicle) && this.motorService.inspectionForm?.controls?.inspectionType?.value == 'Manual Inspection') || this.motorService.isTwoWheeler) {
            const fieldData = await firstValueFrom(this.commonService.getCancelType(this.motorService.productNameForDeviation));
            if (fieldData && fieldData?.result && fieldData.statusCode == 200) {
              let resultData = fieldData?.result ?? [];
              let fieldValue = resultData?.find(p => Number(p?.fieldCode) == Number(this.motorService.productCode))?.fieldValue;
              if (Number(fieldValue) == 1) {
                this.isInspectionByPass = true;
              }

            }
          }

          const PAYLOAD = {
            "source": "SPP",
            "userId": null,//hardcode               this.motorService.userId
            "password": null,//hardcode             this.motorService.password
            "insReferenceNo": "",//hardcode         this.motorService.insReferenceNo
            "proposalId": this.proposalNo,
            "agencyId": "partn",//hardcode 
            "productId": this.motorService.productId || "",
            "intimatorName": this.motorService?.inspectionForm.controls.intimatorName.value,//"MANISH"//hardcode    this.motorService.intimatorName
            "intimatorPhone": this.motorService?.inspectionForm.controls.intimatorMobileNo.value,//"9953199773",//hardcode  this.motorService.intimatorPhone
            "intimatorEmailId": this.motorService?.inspectionForm.controls.intimatorEmailId.value,//"mayur.jawake@assuranceconsulting.in",//hardcode  this.motorService.intimatorEmailId
            "customerName": this.motorService?.inspectionForm.controls.firstName.value + ' ' + this.motorService?.inspectionForm.controls.lastName.value,//"Deep ",//hardcode             this.motorService.customerName
            "customerPhone": this.motorService?.inspectionForm.controls.mobileNo.value,//"8976756464",//hardcode       this.motorService.customerPhone
            "customerEmail": this.motorService?.inspectionForm.controls.emailId.value,//"nikku@gmail.com",//hardcode  this.motorService.customerEmail
            "customerAlternateEmail": this.motorService?.inspectionForm.controls.alternateEmailId.value == "" ? null : this.motorService?.inspectionForm.controls.alternateEmailId.value,//null,//hardcode      this.motorService.customerAlternateEmail
            "productCode": this.motorService.productCode,
            "productName": this?.motorService.businessForm?.value?.productType,
            "vehicleClass": this.motorService.vehicleClassCode,
            "alternateMobileNo": this.motorService?.inspectionForm.controls.alternateMobileNo.value,
            "vehicleSubclass": null,
            "vehicleType": this.motorService.productName,
            "businessType": null,
            "segment": this.motorService.segment,
            "vehicleInspectionLocationAddress": this.motorService.rtoCode?.rtoLocationName,
            "vehicleInspectionLocationAddress1": "",
            "modelId": vehicleDetails.modelCode,
            "make": vehicleDetails.make,
            "makeId": vehicleDetails.makeCode,
            "model": vehicleDetails.model,
            "variantId": vehicleDetails.variantCode,
            "variant": vehicleDetails.variant,
            "vehicleRegNo": this.motorService.businessType.getValue() !== BusinessType.NEW ? this.motorService.businessForm?.value?.registrationNo || vehicleDetails?.vehicleRegistrationNo || '' : BusinessType.NEW,
            "engineNo": vehicleDetails.engineNumber,
            "chassisNo": vehicleDetails.chassisNo,
            "mfgYear": vehicleDetails.manufacturingYear,
            "purposeOfInspection": this.motorService.PurposeOfInspection,//"PreInspection", //hardcode
            "branchId": this.motorService.inspectionBranchId,//100000
            "zipFileSize": "",//hardcode
            "channelType": this.motorService.inspectionForm.controls.channelType.value,//null,//hardcode
            "feeBorneBy": this.motorService.feeBorneBy,//hardcode
            "registrationType": null,//hardcode
            "salesManager": "",//hardcode

            "autoSkip": null,//hardcode
            "inspectionRemarks": null,//hardcode
            "inspectionMode": this.motorService.inspectionMode,//"Physical Inspection",//hardcode
            "inspectionModeId": this.motorService.inspectionForm.controls.inspectionMode.value,//120,//hardcode 
            "inspectionType": this.motorService.inspectionForm.controls.inspectionType.value,//"Inspection To Be Done By Agency",//hardcode
            "inspectionPartner": this.motorService.inspectionpartner,//"Mahindra First Choice Wheels Ltd",//hardcode
            "state": this.motorService.inspectionForm.controls.state.value,//"HARYANA",
            "city": this.motorService.inspectionForm.controls.city.value,//this.motorService.rtoCode?.rtoLocationName,
            "pincode": this.motorService.inspectionForm.controls.pinCode.value,//"122012",
            "lobId": 20, //hardcode
            "lobName": "Motor", //hardcode
            "inspectionSubType": this.motorService.inspectionSubType,
            "isInspectionByPass": this.isInspectionByPass,
            "intimatorCode": this.motorService.smDetailForm.getRawValue()?.intermediaryCode || this.commonService.getUserName(),
            "groupType": this.motorService.groupType,
            "smCode": this.motorService.smDetailForm.getRawValue()?.smCode,
            "createdBy": this.commonService.getUserName()
          }
          const res = await lastValueFrom(this.quoteService.raiseInspection(PAYLOAD));
          if (res.status !== 200) {
            this.notificationService.showError(res?.message, '');
          }
          if (res.status === 200) {
            if (res?.result !== null) {
              if (!this.isInspectionByPass) {
                this.notificationService.showSuccess(res?.message, res?.result.LeadID);
              }
              this.motorService.leadId = res?.result.LeadID;
              if (((this.motorService.isMiscd || this.motorService.isCommercialVehicle) && this.motorService.inspectionForm?.controls?.inspectionType?.value == 'Manual Inspection')) {
                this.isManualInspection = true;
                let payload = this.getCalculatePremiumPayload();
                payload.motor.tpCovers.basicTP = this.motorService.premiumBreakupData?.premiumDetails?.liability.basicTP;
                payload.motor.tpCovers.totalDrivingTPPremium = this.motorService.premiumBreakupData?.premiumDetails?.liability.totalDrivingTPPremium;
                payload.motor.odCovers.noOfTrailer = this.motorService?.trailerAttachedData?.length;
                const response = await lastValueFrom(this.quoteService.calculateProposalPremium(payload));
              }
              await this.onSubmitSaveProposal();
              return true;
            }
            else {
              if (res?.result.insRefNo !== null) {
                this.notificationService.showError(res?.message, `${res?.result.Error}.\n Inspection Refrence No.: ${res?.result.insRefNo}`);
                return false;
              } else {
                this.notificationService.showError(res?.message, `${res?.result.Error}.`);
                return false;
              }
            }
          } else {
            if (res?.result.insRefNo !== null) {
              this.notificationService.showError(res?.message, `${res?.result.Error}.\n Inspection Reference No.: ${res?.result.insRefNo}`);
              return false;
            } else {
              this.notificationService.showError(res?.message, `${res?.result.Error}.`);
              return false;
            }
          }
        } catch (error) {
          console.error('Exception occured in ProposalService while processing raiseInspection', error);
          return false;
        }
      }
      else {
        if (this.motorService.isTwoWheeler || this.motorService.isCommercialVehicle || this.motorService.isMiscd) {
          this.notificationService.showError(`These documents are mandatory please upload (${this.missingDocs})`, '');
        }
        else {
          this.notificationService.showError('Please upload all files. All files are mendatory', '');
        }
        return false;
      }
    }
    else {
      this.motorService.inspectionForm.markAllAsTouched();
      this.focusOnErrorFields();
      return false;
    }
  }

  async getvalidateOtp(): Promise<boolean> {
    try {
      let value = false;
      this.isCustomerConsentSubmitted = true;
      this.isCustomerKYCDetailsSubmitted = true;
      if (this.customerDetailsForm.invalid) return false;
      if (this.customerConsentForm.invalid) return false;
      let customerDetails = this.customerDetailsForm.getRawValue();
      let customerConsent = this.customerConsentForm.value;
      const isCustomerUpdated = await this.customerUpdate();
      if (!isCustomerUpdated) return false;
      const PAYLOAD = {
        "customerId": "",
        "mobileNumber": customerDetails?.mobileNo,
        "salutation": customerDetails?.salutation,
        "customerFirstName": customerDetails?.firstName,
        "customerLastName": customerDetails?.lastName,
        "proposalNumber": this.proposalNo,
        "emailId": customerDetails?.email,
        "modeofOperation": 'otp-MotorSaveProposal',
        "endorsementNumber": customerConsent?.endorsementNumber,
        "productId": this.motorService.productCode || ProductCode.PACKAGE,
        "productName": this.motorService.businessForm.controls.productType.value ? this.motorService.businessForm.controls.productType.value : this.motorService.businessDetail$.getValue()?.productType,
        "otp": customerConsent?.otp,
      }
      const res = await lastValueFrom(this.quoteService.validateOtp(PAYLOAD));
      if (res.status !== 200) {
        this.notificationService.showError(res.result, 'Failed to validate otp!');
        return false;
      } else {
        switch (res.result) {
          case 'OTP Valid':
            this.isOTPTimedOut = false;
            this.isOTPInvalid = false;
            value = true;
            break;
          case 'OTP Invalid':
            this.isOTPInvalid = true;
            this.isOTPTimedOut = false;
            value = false;
            break;
          case 'OTP Expired':
            this.isOTPTimedOut = true;
            this.isOTPInvalid = false;
            value = false;
            break;
        }
        return value;
      }
    } catch {
      return false;
    }
  }
  async onSubmitEcoverNote(isconsolidatedPayment?: boolean): Promise<boolean> {
    try {
      this.isPaymentSubmitted = true;
      //console.log(this.paymentDetailsForm?.invalid, 'this.paymentDetailsForm?.invalid');
      if (this.paymentPayload || this.paymentDetailsForm?.valid) {
        let res;
        if (isconsolidatedPayment) {
          let Payload = {
            proposalNo: this.proposalNo,
            consolidatePayment: true,
            userId: this.motorService.parentImdCode || this.motorService?.smFormControls?.intermediaryCode?.value || this.commonService.getUserName(),
            productCode: this.motorService.productCode
          }

          res = await lastValueFrom(this.quoteService.savepolicyConsolidated(Payload));
          if (res.status === 200) {
            let proposalNumber = [this.proposalNo];
            const checkRes = await this.checkPaymentLimitAndSubmissionDateLimit(PolicyConstant.CREATEPOLICY, false, proposalNumber);

          }
        }
        else {
          res = await lastValueFrom(this.quoteService.payWithPaymentMode(this.paymentPayload));
        }
        if (res.status !== 200) {
          this.notificationService.showError(res.message, 'Failed!');
          return false;
        } else {
          this.notificationService.showSuccess(res.message, 'Success!');
          if (this.router.url.startsWith('/partner-portal/commercial/fire')) {
            this.router.navigate(['/partner-portal/commercial/fire/generateFirePolicy'], {
              queryParams: { proposalNo: this.encodeBaseString(this.proposalNo) }
            });
          } else {
            this.router.navigate(['/partner-portal/motor/vehicle/generateMotorPolicy'], {
              queryParams: { proposalNo: this.motorService.encodeProposalNo }
            });
          }
          return true;
        }
      } else {
        return false;
      }
    } catch (error) {
      //console.log(error);
      return false;
    }
  }

  async sendEmailLink() {
    this.emailPaymentLink = '';
    if (this.paymentDetailsForm?.invalid) return null;
    this.isPaymentSubmitted = false;
    if (this.paymentDetailsForm?.controls?.paymentBy?.value === 'Customer') {
      const res = await lastValueFrom(this.quoteService.sendPaymentLink(this.proposalNo));
      this.emailPaymentLink = res?.result?.url;
    } else {
      // const res = await lastValueFrom(this.quoteService.sendPaymentLinkToImd(this.proposalNo || null,
      //   this.motorService?.smFormControls?.intermediaryCode?.value||this.commonService?.getUserName()));
      const payload = {
        proposalNumber: this.proposalNo,
        imdCode: this.motorService?.smFormControls?.intermediaryCode?.value || this.commonService.getUserName(),
        mobileNumber: this.paymentDetailsForm?.controls?.mobileNo?.value,
        emailId: this.paymentDetailsForm?.controls?.email?.value,
        paymentType: this.paymentDetailsForm?.controls?.paymentMode?.value
      }
      const res = await lastValueFrom(this.quoteService.sendEmailPaymentLinkToImd(payload));
      this.emailPaymentLink = res?.result?.url;
    }
    // if (!res) {
    //   this.notificationService.showError('Failed to send Email Link!', 'Failed!');
    //   return null;
    // } else {
    this.notificationService.showSuccess(`Successfully shared payment link to ${this.paymentDetailsForm?.controls?.paymentBy?.value || 'Customer'}!`, 'Sucess');
    // this.router.navigate(['/partner-portal']);
    //}
  }

  // openKycDialog(url: string, Aggregator_KYC_Req_No: string, IC_KYC_No: string): void {
  //   this.dialog.open(KycVerificationDialogComponent, {
  //     data: { url,Aggregator_KYC_Req_No,IC_KYC_No }  
  //   });
  // }
  // openKycDialog(url: string, Aggregator_KYC_Req_No: string, IC_KYC_No: string): void {
  //   // window.open(url, '_blank');
  //   window.open(
  //     url,
  //     '_blank',
  //     'width=800,height=600'
  //   );
  //   window.addEventListener('message', this.handleChildMessage.bind(this), false);
  // }

  openKycDialog(url: string, Aggregator_KYC_Req_No: string, IC_KYC_No: string): void {
    // Open the child window
    const childWindow = window.open(url, '_blank', 'width=1000,height=600');

    // // Set up an event listener to capture messages from the child window
    // const messageHandler = (event: MessageEvent) => {
    //   // Check that the message comes from the expected origin
    //   if (event.origin === 'https://kycapi-uat.libertyinsurance.in') {
    //     //console.log('Message from child window:', event.data);

    //     // Process the received payload and response
    //     const { payload, response } = event.data;
    //     //console.log('Payload:', payload);
    //     //console.log('Response:', response);

    //     alert('Captured payload and response from child window!');
    //   }
    // };

    // // Add the event listener
    // window.addEventListener('message', messageHandler);

    // // Optional cleanup to remove the listener when the child window is closed
    // const checkChildClosed = setInterval(() => {
    //   if (childWindow?.closed) {
    //     clearInterval(checkChildClosed);
    //     window.removeEventListener('message', messageHandler);
    //     //console.log('Child window closed. Listener removed.');
    //   }
    // }, 500);
  }

  // handleChildMessage(event: MessageEvent): void {
  //   if (event.origin === 'https://kycapi-uat.libertyinsurance.in') {
  //     //console.log('Payload from child window:', event.data);

  //     if (event.data.success) {
  //       alert('KYC completed successfully!');
  //     } else {
  //       alert('KYC failed.');
  //     }
  //   } else {
  //     //console.log('Received message from an untrusted origin:', event.origin);
  //   }
  // }

  // patchRiskFormForInsight(riskDetals: any, forProposal?: boolean): void {
  //   let odStartDate = riskDetals?.odStartDate?.includes('.000+') ? riskDetals?.odStartDate?.split('.000+')[0] : riskDetals?.odStartDate;
  //   let odEndDateTs = riskDetals?.odEndDate?.includes('.000+') ? riskDetals.odEndDate?.split('.000+')[0] : riskDetals?.odEndDate;
  //   let tpStartDateTs = riskDetals?.tpStartDate?.includes('.000+') ? riskDetals.tpStartDate?.split('.000+')[0] : riskDetals?.tpStartDate;
  //   let tpEndDateTs = riskDetals?.tpEndDate?.includes('.000+') ? riskDetals.tpEndDate?.split('.000+')[0] : riskDetals?.tpEndDate;
  //   this.motorService.riskForm.patchValue({
  //     odTenure: this.motorService?.productTenure?.odTenure,
  //     tpTenure: this.motorService?.productTenure?.tpTenure,
  //     odStartDate: odStartDate || '',
  //     odEndDate: odEndDateTs || '',
  //     tpStartDate: tpStartDateTs || '',
  //     tpEndDate: tpEndDateTs || '',
  //   });
  // }

  async generateOTP(customerData: any, productName: any, productCode: any, endorsementNumber: any): Promise<boolean> {
    try {
      this.isCustomerConsentSubmitted = true;
      //this.isCustomerKYCDetailsSubmitted = true;
      // if (this.customerDetailsForm.invalid) return false;
      if (this.customerConsentForm.invalid) return false;
      // let customerDetails = this.customerDetailsForm.getRawValue();
      let customerConsent = this.customerConsentForm.value;
      //const isCustomerUpdated = await this.customerUpdate(this.verifyCustomerKycData);
      //if (!isCustomerUpdated) return false;
      const PAYLOAD = {
        "customerId": "",
        "mobileNumber": customerData?.MobileNo,
        "salutation": "",
        "customerFirstName": customerData?.FirstName,
        "customerLastName": customerData?.LastName,
        "proposalNumber": null,
        "emailId": customerData?.EmailId,
        "modeofOperation": this.customerConsentForm.value.consentMode,
        "endorsementNumber": endorsementNumber,
        "productId": productCode,
        "productName": productName,
        "emailIndicator": customerConsent?.emailIndicator,
        "smsIndicator": customerConsent?.smsIndicator,
        "whatsappIndicator": customerConsent?.whatsAppIndicator || false,
        "partnerCopyIndicator": customerConsent?.partnerCopyIndicator,
        "paymentBehalfIndicator": customerConsent?.paymentBehalfIndicator,
        "panNumber": customerData?.PanNo
      }
      if (this.customerConsentForm.value.consentMode === 'OTP') {
        PAYLOAD.modeofOperation = 'otp-MotorEndorsement';
      }
      const res = await lastValueFrom(this.quoteService.getCustomerConsent(PAYLOAD));
      if (res.status !== 200) {
        this.notificationService.showError(res.message, 'Failed to get Customer Consent!');
        return false;
      } else {
        this.notificationService.showSuccess(res?.message, 'Success!');
        return true;
      }
    } catch {
      return false;
    }
  }

  async generateCancelOTP(productCode: any, cancellationRequestNumber: any, cancellationPolicyNumber: any): Promise<boolean> {
    try {
      const mobileNo = this.customerConsentForm.get('mobileNumber')?.value;
      let customerData: any;
      customerData = {
        "MobileNo": mobileNo,
        "OTP": "",
        "CustomerId": "",
        "EmailId": ""
      }
      if (!this.disableConsentMode && this.customerConsentForm.invalid) return false;
      this.isCustomerConsentSubmitted = true;
      this.isOtpSending = false;
      let customerConsent = this.customerConsentForm.value;

      const PAYLOAD = {
        "mobileNumber": customerData?.MobileNo,
        "proposalNumber": null,
        "otp": customerData?.OTP,
        "modeofOperation": this.customerConsentForm.value.consentMode,
        "endorsementNumber": cancellationRequestNumber,
        "productId": productCode,
        "smsIndicator": customerConsent?.smsIndicator,
        "cancellationRequestNumber": cancellationPolicyNumber,
        "customerId": customerData?.CustomerId,
        "emailId": customerData?.EmailId,
      }
      if (this.customerConsentForm.value.consentMode === 'OTP') {
        PAYLOAD.modeofOperation = 'otp-MotorCancellation';
      }
      const res = await lastValueFrom(this.quoteService.generateCancellationOtp(PAYLOAD));
      if (res.status !== 200) {
        this.notificationService.showError(res.message, 'Failed to sent Otp!');
        return false;
      } else {
        this.isOtpSending = true;
        this.notificationService.showSuccess(res?.message, 'Successfully sent the otp!');
        return true;
      }
    } catch {
      return false;
    }
  }

  async getvalidateOtpForEndorsement(customerData: any, productName: any, productCode: any, endorsementNumber: any): Promise<boolean> {
    try {
      let value = false;
      this.isCustomerConsentSubmitted = true;
      //this.isCustomerKYCDetailsSubmitted = true;
      //if (this.customerDetailsForm.invalid) return false;
      if (this.customerConsentForm.invalid) return false;
      //let customerDetails = this.customerDetailsForm.getRawValue();
      let customerConsent = this.customerConsentForm.value;
      // const isCustomerUpdated = await this.customerUpdate(this.verifyCustomerKycData);
      //if (!isCustomerUpdated) return false;
      const PAYLOAD = {
        "customerId": "",
        "mobileNumber": customerData?.MobileNo,
        "salutation": "",
        "customerFirstName": customerData?.FirstName,
        "customerLastName": customerData?.LastName,
        "proposalNumber": endorsementNumber,
        "emailId": customerData?.EmailId,
        "modeofOperation": 'otp-MotorEndorsement',
        "endorsementNumber": endorsementNumber,
        "productId": productCode,
        "productName": productName,
        "otp": customerConsent?.otp,
      }
      const res = await lastValueFrom(this.quoteService.validateOtp(PAYLOAD));
      if (res.status !== 200) {
        this.notificationService.showError(res.result, 'Failed to validate otp!');
        return false;
      } else {
        switch (res.result) {
          case 'OTP Valid':
            this.isOTPTimedOut = false;
            this.isOTPInvalid = false;
            value = true;
            this.notificationService.showSuccess('OTP verified successfully.', '');
            break;
          case 'OTP Invalid':
            this.isOTPInvalid = true;
            this.isOTPTimedOut = false;
            value = false;
            break;
          case 'OTP Expired':
            this.isOTPTimedOut = true;
            this.isOTPInvalid = false;
            value = false;
            break;
        }
        return value;
      }
    } catch {
      return false;
    }
  }

  resendOtpUsingEndorsement(isShowRaiseInspection: boolean): void {
    this.resendEndormentOtpSubject.next(isShowRaiseInspection);
  }
  navigateInspection() {
    const navigationExtras = {
      state: {
        tabCode: 'Inspection'
      }
    };
    this.router.navigate(['/partner-portal/insights/view-status'], navigationExtras);
  }

  async patchBusinessDetailsFormFromInspection(motorDetails: any, customerDetails: any, vehicleDetails: any) {
    const RTO_CODE = motorDetails.rtoCode + ' ' + vehicleDetails.registrationPlace + ' Zone ' + motorDetails.rtoZone;
    this.motorService?.businessForm.patchValue({
      chassisNo: vehicleDetails?.chassisNo,
      productType: motorDetails?.productType,
      rtoCode: RTO_CODE ? RTO_CODE : "",
      // policyNo: new FormControl(''),
      registrationNo: vehicleDetails?.vehicleRegistrationNo,
      productCode: motorDetails?.productCode,
      businessType: customerDetails?.businessType,
      customerType: customerDetails?.customerType
    });
    this.motorService.customerTypeId.next(customerDetails?.customerType === 'Corporate' ? CustomerType.CORPORATE : CustomerType.INDIVIDUAL);
    this.motorService.rtoCode = {
      "registrationZone": motorDetails.rtoZone,
      "rtoLocationCode": motorDetails.rtoCode,
      "rtoLocationName": vehicleDetails.registrationPlace
    }

    this.motorService.productCode = motorDetails?.productCode || "";
    this.motorService.productUin = motorDetails?.productUin || "";
    this.motorService.gcProductCode = motorDetails?.gcProductCode || '';
    this.motorService.segment = motorDetails?.vehicleSegment || '';
    this.motorService.segment = motorDetails?.vehicleSegment || '';
    // this.motorService.productTypeId = businessDetails?.quoteDetails?.productTypeId || '';
  }
  isValueNA(data: any[]): boolean {
    return data?.some((row) =>
      Object.keys(row).some(key => row[key] === 'N/A' || row[key] === null || row[key] === undefined)
    );
  }
  getTableColumns(data: any): options[] {
    return Object.keys(data).map(k => {
      return {
        key: k,
        label: this.convertFirstCharToCapital(k)
      }
    });
  }
  convertFirstCharToCapital(str: string): string {
    return str?.charAt(0).toUpperCase() + str.slice(1);
  }
  getRsdDates(endDate?: Moment): void {
    let businessType = '';
    if (this.motorService?.businessType?.getValue()?.toUpperCase() === 'RENEWAL') {
      businessType = 'RENEW';
    } else {
      businessType = this.motorService?.businessType.getValue()?.toUpperCase();
    }
    if (this.motorService.isBusinessTypeNew && endDate && endDate?.isBefore(moment())) {
      endDate = moment();
    }
    if (this.motorService.premiumBreakupData?.premiumDetails?.inspectionDetail?.inspectionRSDLogic) {
      let daysToAdd: number;
      daysToAdd = Number(this.motorService.premiumBreakupData?.premiumDetails?.inspectionDetail?.inspectionRSDLogic);
      this.motorService.inspectionRSDLogic = daysToAdd;
    }
    const PAYLOAD = {
      "productTypeId": this.motorService.productTypeId || '0',
      "businessType": businessType,
      "selectedStartDate": !endDate ? moment().format(DateFormat.YYYY_MM_DD_T_HH_MM) : endDate.format(DateFormat.YYYY_MM_DD_T_HH_MM),
      "previousPolicyEndDate": "",
      "deviationApproveDate": "",
      "paymentDate": "",
      "isActiveTPDetails": '',
      "prevActiveTpEndDate": '',
      "inspectionRSDLogic": this.motorService.inspectionRSDLogic || '',
      "previousPolicyDetails": {
        "odEndDate": "",
        "tpEndDate": ""
      }
    }
    if (!this.motorService?.isBusinessTypeNew) {
      PAYLOAD.selectedStartDate = '';
      if (this.motorService.isPolicySODP) {
        if (!this.motorService.currentStep$?.getValue() && this.motorService.isBusinessTypeRollOver && this.motorService.isProceedSuccess$.getValue() && this.motorService.isGetQuoteCompleted !== 2) { //TP Alignment
          PAYLOAD.prevActiveTpEndDate = moment(this.motorService.vehicleData?.activeTpDetails?.tpPolicyEndDate)?.format(DateFormat.YYYY_MM_DD) || ''
        }
        else if (!this.motorService.currentStep$?.getValue() && this.motorService.isBusinessTypeRenew) { //TP Alignment
          PAYLOAD.prevActiveTpEndDate = moment(this.motorService.normalizeDateToCustomISO(this.motorService.renewDetails?.thirdGridDetails[0]?.tppolicyEndDate))?.format(DateFormat.YYYY_MM_DD) || moment(this.motorService.activeTpPolicyForm?.controls?.tpPolicyEndDate?.value)?.format(DateFormat.YYYY_MM_DD) || ''
        }
        else {
          PAYLOAD.prevActiveTpEndDate = moment(this.motorService.activeTpPolicyForm?.controls?.tpPolicyEndDate?.value)?.format(DateFormat.YYYY_MM_DD);
        }
      }
      if (this.motorService?.isBusinessTypeRollOver || this.motorService?.isBusinessTypeUsed) {
        if (!endDate) {
          if (this?.motorService.previousPolicyForm?.controls?.previousPolicyAavilable?.value) {
            if (this.motorService.isProceedSuccess$.getValue() && this.motorService.vehicleData?.sudarshana?.policyDetails && this.motorService.vehicleData?.sudarshana?.policyDetails[0]?.policyEndDate?.length) {
              endDate = moment(this.motorService.vehicleData?.sudarshana?.policyDetails[0]?.policyEndDate, DateFormat.YYYY_MM_DD_HH_MM_SS_DOT_S);
            } else {
              endDate = this.motorService.previousPolicyForm.controls.previousPolicyEndDate.value ? moment(this.motorService.previousPolicyForm.controls.previousPolicyEndDate.value) : null;
            }
          } else {
            const DATE = (this.motorService.getRiskStartDate(true) as Moment)?.subtract(1, 'day');
            endDate = DATE ? DATE : moment()?.subtract(1, 'day');
          }
        }
        const PREV_POLICY_END_DATE_MOMENT = endDate;
        const PREV_POLICY_END_DATE = PREV_POLICY_END_DATE_MOMENT?.isValid()
          ? PREV_POLICY_END_DATE_MOMENT.format(DateFormat.YYYY_MM_DD) : '';
        PAYLOAD.previousPolicyDetails.odEndDate = PREV_POLICY_END_DATE || '';
        PAYLOAD.previousPolicyDetails.tpEndDate = PREV_POLICY_END_DATE || '';
        // this.motorService.previousPolicyForm.controls.previousPolicyEndDate.patchValue(PREV_POLICY_END_DATE_MOMENT.toDate());
      } else {
        const PREV_POLICY_END_DATE_MOMENT = !endDate ? this.motorService.policyEnddate?.split(' ')[0] : moment(endDate)?.format(DateFormat.YYYY_MM_DD);
        const PREV_POLICY_END_DATE = PREV_POLICY_END_DATE_MOMENT;
        PAYLOAD.previousPolicyEndDate = PREV_POLICY_END_DATE_MOMENT || '';
        PAYLOAD.previousPolicyDetails.odEndDate = PREV_POLICY_END_DATE || '';
        PAYLOAD.previousPolicyDetails.tpEndDate = PREV_POLICY_END_DATE || '';
      }
      if (this.motorService.isPolicySODP) {
        PAYLOAD.previousPolicyDetails.tpEndDate = PAYLOAD.prevActiveTpEndDate;
      }

    }

    this.quoteService.riskDetails(PAYLOAD).subscribe((res) => {
      if (res) {
        this.motorService.isBreakin = res?.result?.isBreakIn;
        this.patchRiskForm(res?.result);
        if (!this.motorService.isBusinessTypeNew && !this.motorService.currentStep$?.getValue()) {
          this.motorService.setNcbDiscountData();
        }
        this.motorService.notifyRiskStartDateUpdated();
      }
    });
  }
  handleKycDocumentsValidation(selectedDocument: string): void {
    if (selectedDocument) {
      const MIN_LENGTH = selectedDocument === 'proposerAadhaarNumber' ? 4 : selectedDocument === 'proposerCKYCNo' ? 14 : 10;
      let validators = [Validators.required, Validators.minLength(MIN_LENGTH)];
      if (selectedDocument === 'proposerPAN') {
        validators.push(Validators.pattern(REGEX.panNumber));
      } else {
        const INDEX = validators.findIndex(v => v === Validators.pattern(REGEX.panNumber));
        if (INDEX !== -1) {
          validators.pop();
        }
      }
      if (selectedDocument === 'proposerAadhaarNumber') {
        this.customerDetailsFormControls.gender.patchValue('M');
        this.customerDetailsFormControls.gender.addValidators([Validators.required]);
        this.customerDetailsFormControls.gender.updateValueAndValidity({ emitEvent: false });
      } else {
        this.customerDetailsFormControls.gender.clearValidators();
        this.customerDetailsFormControls.gender.updateValueAndValidity({ emitEvent: false });
      }
      this.customerDetailsFormControls[selectedDocument].addValidators(validators);
      this.customerDetailsFormControls[selectedDocument].updateValueAndValidity({ emitEvent: false });
    }
    if (selectedDocument !== 'proposerAadhaarNumber') {
      this.customerDetailsFormControls.proposerAadhaarNumber.reset('');
      this.customerDetailsFormControls.proposerAadhaarNumber.clearValidators();
      this.customerDetailsFormControls.proposerAadhaarNumber.updateValueAndValidity({ emitEvent: false });
    }
    if (selectedDocument !== 'proposerPAN') {
      this.customerDetailsFormControls.proposerPAN.reset('');
      this.customerDetailsFormControls.proposerPAN.clearValidators();
      this.customerDetailsFormControls.proposerPAN.updateValueAndValidity({ emitEvent: false });
    }
    if (selectedDocument !== 'proposerCKYCNo') {
      this.customerDetailsFormControls.proposerCKYCNo.reset('');
      this.customerDetailsFormControls.proposerCKYCNo.clearValidators();
      this.customerDetailsFormControls.proposerCKYCNo.updateValueAndValidity({ emitEvent: false });
    }
  }

  checkIDVValidation(): boolean {
    let vehicleIdvLowerValue = this.motorService.vehicleIdvLowerValue;
    let vehicleIdvHigherValue = this.motorService.vehicleIdvHigherValue;
    let vehicleDetails = this.motorService.vehicleForm.getRawValue()
    let enteredVehicleIDV = vehicleDetails.vehicleIdv;
    let idvHigherSide = enteredVehicleIDV > parseInt(vehicleIdvHigherValue) ? true : false;
    let idvLowerSide = enteredVehicleIDV < parseInt(vehicleIdvLowerValue) ? true : false;

    if (idvHigherSide) {
      this.notificationService.showError("IDV Value cannot be higher than ₹" + vehicleIdvHigherValue, '');
      this.focusOnErrorFields();
      return false;
    }
    else if (idvLowerSide) {
      this.notificationService.showError("IDV Value cannot be less than ₹" + vehicleIdvLowerValue, '');
      this.focusOnErrorFields();
      return false;
    }
    else {
      return true;
    }
  }

  checkPricingValidation(): boolean {
    const enteredRaw = this.motorService?.discountFormControls?.isDiscountOrLoadingPer?.value;

    // 1. Empty check
    if (this.isEmpty(enteredRaw)) {
      return false;
    }

    const entered = Number(enteredRaw) || 0;

    // 2. Pricing deviation logic
    let isPricingDeviation = false;

    if (this.isProposalOn) {
      isPricingDeviation = this.motorService.isFromPricingDeviation;

    } else if (!this.motorService.isBusinessTypeRenew) {
      isPricingDeviation = true;

    } else {
      const renew = this.motorService.renewDetails;
      const optimized = renew?.optimizedPricing?.toLowerCase();

      if (optimized === 'true') {
        isPricingDeviation = false;

      } else if (optimized === 'false') {
        const isException = renew?.exceptionFlag === 'true' && renew?.nstp === false;
        isPricingDeviation = !isException;
      }
    }

    // 3. Threshold calculation
    let threshold = 0;

    if (this.isProposalOn) {
      threshold = this.motorService.isFromPricingDeviation ? this.motorService.approvedODDiscount : this.motorService.brmsODDiscount;
    } else {
      threshold = isPricingDeviation ? this.motorService.maxDiscountValue : this.motorService.brmsODDiscount;
    }

    const thresholdValue = Number(threshold) || 0;

    // 4. Out-of-range flag
    if (this.isProposalOn) {
      this.motorService.isDiscountOrLoadingPerOutOfRange = this.motorService.isFromPricingDeviation;
    } else if (!this.motorService.isFromPricingDeviation && isPricingDeviation) {
      this.motorService.isDiscountOrLoadingPerOutOfRange = entered > this.motorService.brmsODDiscount ? true : false;
    }
    else {
      this.motorService.isDiscountOrLoadingPerOutOfRange = this.motorService.isFromPricingDeviation;
    }

    // 5. Final validation
    if (entered > thresholdValue) {
      this.showError(thresholdValue);
      return false;
    }

    this.isDiscountOrLoadingPerOutOfRange = false;
    return true;
  }


  private isEmpty(value: any): boolean {
    return value === "" || value === null || value === undefined || value === "null";
  }

  private showError(threshold: number): void {
    const formatted = this.decimalPipe.transform(threshold, '1.2-2');
    this.isDiscountOrLoadingPerOutOfRange = true;
    this.notificationService.showError(`Discount exceeded threshold limit ${formatted}%`, "");
    this.focusOnErrorFields();
  }

  async convertFileToBase64(file: File): Promise<boolean> {
    this.base64String = ''
    const reader = new FileReader();
    reader.onload = () => {
      // The result is a Base64 string
      let base64String = reader.result as string;
      const base64Prefix = 'data:image/jpeg;base64,';
      const base64PDFPrefix = 'data:application/pdf;base64,';
      if (base64String.startsWith(base64Prefix)) {
        base64String = base64String.slice(base64Prefix.length);
      }
      else if (base64String.startsWith(base64PDFPrefix)) {
        base64String = base64String.slice(base64PDFPrefix.length);
      }
      this.base64String = base64String;

    };
    reader.readAsDataURL(file);
    return true;
  }

  async uploadKYCFile(file: any, kycDocumentCategory: string, fileType: string): Promise<boolean> {
    let payload = {
      aggregatorKycReqNo: this.verifyCustomerKycData.Aggregator_KYC_Req_No,
      iCKycNo: this.verifyCustomerKycData.IC_KYC_No,
      kycDocumentCategory: kycDocumentCategory,
      kycDocType: fileType,
      kycDocument: this.base64String,
      otherAddFLD1: "",
      otherAddFLD2: "",
      otherAddFLD3: "",
      otherAddFLD4: "",
      otherAddFLD5: "",
      otherAddFLD6: ""
    }
    this.quoteService.uploadKycFile(payload).subscribe((res) => {
      if (res && res.result && res.status === 200) {
        if (res.result.KYCDocStatus && res.result.KYCDocStatus === "1") {
          this.isKycDocumnetUploadButton = false;
          this.notificationService.showSuccess("KYC document upload is successful", "");
          return true;
        }
        else {
          this.isKycDocumnetUploadButton = true;
          this.notificationService.showError("KYC document upload is fail", "");
          return false;
        }
      }
      else {
        this.isKycDocumnetUploadButton = true;
        this.notificationService.showError("KYC document upload is fail", "");
        return false;
      }
    });
    return true;
  }

  async updateProposalStage(insightStage?: InsighStatus): Promise<boolean> {
    try {
      let stage = insightStage || InsighStatus.PREMIUM_CALCULATED;
      await lastValueFrom(this.quoteService.updateProposalStage(this.proposalNo, stage));
      this.motorService.isReferral = false;
      return true;
    } catch (error) {
      //console.log(error);
      return false;
    }
  }
  handleNomineeDetails(): void {
    if (!this.motorService.currentStep$.getValue()) return;
    // if(this.motorService.TPCoverFormControls.paCoverOwnerDriver.value || this.motorService.isCustomerCorporate){
    if (this.motorService.TPCoverFormControls.paCoverOwnerDriver.value) {
      this.nomineeDetailForm.controls.nomineeName.setValidators([Validators.required]);
      this.nomineeDetailForm.controls.nomineeAge.setValidators([Validators.required, Validators.min(1), Validators.max(99)]);
      this.nomineeDetailForm.controls.nomineeRelationship.setValidators([Validators.required]);
    } else {
      this.nomineeDetailForm.controls.nomineeName.clearValidators();
      this.nomineeDetailForm.controls.nomineeAge.clearValidators();
      this.nomineeDetailForm.controls.nomineeRelationship.clearValidators();
    }
    this.nomineeDetailForm.controls.nomineeName.updateValueAndValidity({ emitEvent: false });
    this.nomineeDetailForm.controls.nomineeAge.updateValueAndValidity({ emitEvent: false });
    this.nomineeDetailForm.controls.nomineeRelationship.updateValueAndValidity({ emitEvent: false });
  }
  splitGstInNumber(gstInNumber: string) {
    let gstN1 = '';
    let gstN2 = '';
    let gstN3 = '';
    let isNumberOnly = true;
    for (let i = 0; i <= gstInNumber?.length; i++) {
      const num = Number(gstInNumber.charAt(i));
      //console.log(num);
      if (!isNaN(num) && isNumberOnly) {
        gstN1 += gstInNumber.charAt(i);
      } else {
        isNumberOnly = false;
        if (i < (gstInNumber?.length - 3)) {
          gstN2 += gstInNumber.charAt(i);
        } else {
          gstN3 += gstInNumber.charAt(i);
        }
      }
    }
    return {
      gstN1: Number(gstN1),
      gstN2,
      gstN3
    }
  }

  get customerConsentFormControls() {
    return this.customerConsentForm.controls;
  }
  patchRenewalFinancierDetails(vehicleDetails: any): void {
    if (!this.financierForm) {
      this.financierForm = this.getFinancierForm();
    }
    this.financierForm.patchValue({
      financierId: vehicleDetails?.financierId,
      financierType: vehicleDetails?.financierType,
      financierName: vehicleDetails?.financierName,
      financierCode: vehicleDetails?.financierCode,
    });
  }

  showElectricalAcc(electricalIDV, nonElectricalIDV, biFuelKitIDV, externalBifuelKitType) {
    if (this.isDeviations) {
      this.motorService.isElectricalAccApproved = (electricalIDV > this.motorService.idvElectricalMax) || (electricalIDV < this.motorService.idvElectricalMin);
    }
    else {
      this.motorService.isElectricalAccApproved = false;
    }
    if (this.isDeviations) {
      this.motorService.isNonElectricalAccApproved = (nonElectricalIDV > this.motorService.idvNonElectricalMax) || (nonElectricalIDV < this.motorService.idvNonElectricalMin);
    }
    else {
      this.motorService.isNonElectricalAccApproved = false;
    }
    if (this.isDeviations) {
      const biFuelKitIDVValue = biFuelKitIDV || 0;
      const formattedValue = this.decimalPipe.transform(biFuelKitIDVValue, '1.2-2');
      const enteredIDVValue = parseFloat(formattedValue.replace(/,/g, '')) || 0;
      console.log(enteredIDVValue, "enteredIDVValue");
      if (externalBifuelKitType === 'CNG') {
        this.motorService.isExternalBifuelKitApproved = (enteredIDVValue > this.motorService.idvCNGMax) || (enteredIDVValue < this.motorService.idvCNGMin);
      }
      else if (externalBifuelKitType === 'LPG') {
        this.motorService.isExternalBifuelKitApproved = (enteredIDVValue > this.motorService.idvLPGMax) || (enteredIDVValue < this.motorService.idvLPGMin);
      }
    }
    else {
      this.motorService.isExternalBifuelKitApproved = false;
    }
  }

  isDateYear_1930(date: Moment): boolean {
    return date?.year() === 1930;
  }

  patchCustomerDetails(quoteDetail: any) {
    this.motorService.customerId = quoteDetail?.vehicleDetails?.customerId;
    if (!this.motorService.customerId) {
      this.motorService.customerId = quoteDetail?.customerDetails?.customerId;
    }
    this.motorService.customerDetails = {
      customerId: this.motorService?.customerId || null,
      "insuredAlternateEmail": quoteDetail?.customerDetails?.insuredAlternateEmail || null,
      "insuredAlternateMobileno": quoteDetail?.customerDetails?.insuredAlternateMobileno || null,
      "insuredDob": quoteDetail?.customerDetails?.insuredDob || null,
      "insuredEmail": quoteDetail?.customerDetails?.insuredEmail || null,
      "insuredFirstName": quoteDetail?.customerDetails?.insuredFirstName || null,
      "insuredMobileno": quoteDetail?.customerDetails?.insuredMobileno || null,
      "insuredPanNo": quoteDetail?.customerDetails?.insuredPanNo || null,
      "insuredState": quoteDetail?.customerDetails?.insuredState || null,
      "kycInitiatedBy": quoteDetail?.customerDetails?.kycInitiatedBy || null
    }
  }

  patchShareCustomerDetails(customerForm: any) {
    this.motorService.customerDetails = {
      "insuredAlternateEmail": null,
      "insuredAlternateMobileno": null,
      "insuredDob": null,
      "insuredEmail": customerForm.email || null,
      "insuredFirstName": customerForm.name || null,
      "insuredMobileno": customerForm.mobileNumber || null,
      "insuredPanNo": null,
      "insuredState": null,
    }
  }
  decryptBaseString(baseStr?: string, baseNo?: number): string {
    const DECODED_STR = CryptoJS.enc.Base64.parse(baseStr) || '';
    return CryptoJS.enc.Utf8.stringify(DECODED_STR)?.replace('[', '')?.replace(']', '')?.trim() || baseStr;
  }
  encodeBaseString(proposalNumber?: string): string {
    const ENCODED_STR = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(`[${proposalNumber || ''}]`));
    return `00000${ENCODED_STR}`;
  }
  async getKycDetails(): Promise<kycDetailsResult> {
    // await this.updateProposalStage(InsighStatus.PENDING_CONSENT);
    const res = await lastValueFrom(this.quoteService.getKycDetails(this.proposalNo));
    if (res?.status !== 200) {
      this.notificationService.showError(res?.message, 'Failed');
      let data = {
        path: '',
        paramsValue: 30,
        tab: '',
        subTab: '',
        proposalNo: this?.proposalNo
      }
      this.router.navigate(['partner-portal/insights/view-status'], { state: data });
      return null;
    } else {
      return res?.result;
    }
  }
  async patchCustomerKycDetails(): Promise<void> {
    const res = await this.getKycDetails();
    if (!res) return;
    let customerNameSplitted = res?.kycDetails?.customerName?.trim().split(' ') || null;
    let firstName = "";
    let middleName = "";
    let lastName = "";
    if (customerNameSplitted?.length === 3) {
      firstName = customerNameSplitted[0];
      middleName = customerNameSplitted[1];
      lastName = customerNameSplitted[2];
    }
    else if (customerNameSplitted?.length === 2) {
      firstName = customerNameSplitted[0];
      lastName = customerNameSplitted[1];
    }
    else if (customerNameSplitted?.length === 1) {
      firstName = customerNameSplitted[0];
    }
    else if (customerNameSplitted?.length > 3) {
      firstName = customerNameSplitted[0];
      middleName = customerNameSplitted[1];
      lastName = customerNameSplitted.slice(2).join(' ');
    }
    if (!this.customerDetailsForm) {
      this.customerDetailsForm = this.getCustomerKYCDetailsForm();
    }
    const dateObj = (date: string) => {
      const DATE = moment(date, 'DD-MM-YYYY');
      return DATE?.isValid() ? DATE : '';
    };
    this.customerDetailsForm.patchValue({
      firstName: res?.kycDetails?.firstName ? res?.kycDetails?.firstName || '' :
        this.motorService.isLengthNotZero(customerNameSplitted) ?
          firstName || '' : '',
      salutation: res?.kycDetails?.namePrefix || '',
      lastName: res?.kycDetails?.firstName ? res?.kycDetails?.lastName || '' :
        this.motorService.isLengthNotZero(customerNameSplitted) ? lastName || '' : '',
      middleName: res?.kycDetails?.firstName ? res?.kycDetails?.middleName || '' : this.motorService.isLengthNotZero(customerNameSplitted) ? middleName || '' : '',
      companyName: res?.kycDetails?.customerName || '',
      gender: res?.kycDetails?.gender?.toUpperCase()?.charAt(0) || '',
      dob: dateObj(res?.kycDetails?.dob) || '',
      doi: dateObj(res?.kycDetails?.dob) || '',
      mobileNo: res?.kycDetails?.mobile || '',
      email: res?.kycDetails?.email || '',
      proposerPAN: res?.kycDetails?.pan || '',
      proposerAadhaarNumber: res?.kycDetails?.aadhaar || '',
      proposerCKYCNo: res?.kycDetails?.ckycNumber || '',
      pinCode: res?.pinCodeMaster?.pinCode || '',
      state: res?.pinCodeMaster?.stateName || '',
      city: res?.pinCodeMaster?.cityDistrictName || '',
      mailingAreaOrLocality: res?.pinCodeMaster?.pinLocality,
      mailingTownOrCity: res?.pinCodeMaster?.cityDistrictName,
      mailingDistrictCd: res?.pinCodeMaster?.cityDistrictCode,
      mailingStateCd: res?.pinCodeMaster?.stateCode,
      mailingDistrict: res?.pinCodeMaster?.stateName,
      // permanentAddress: res?.kycDetails?.customerAddress1 || '',
      // permanentAddress2: res?.kycDetails?.customerAddress2 || '',
      // permanentAddressPincode: res?.kycDetails?.pinCodeC,
      // permanentAddressState: res?.kycDetails?.customerStateC,
      // permanentAddressCity: res?.kycDetails?.customerCityC,
      otherAddFLD1: res?.kycDetails?.customerAddress1P || '',
      otherAddFLD2: res?.kycDetails?.customerAddress2P || '',
      // kycInitiatedBy: res?.kycDetails?.kycInitiatedBy || '',
    });
    this.isCustomerKycPatched$?.next(true);
    this.motorService.disableForm(this.customerDetailsForm);
    this.customerDetailsFormControls.permanentAddress.enable({ emitEvent: false });
    this.customerDetailsFormControls.permanentAddress2.enable({ emitEvent: false });
    this.customerDetailsFormControls.permanentAddressPincode.enable({ emitEvent: false });
    this.customerDetailsFormControls.permanentAddressState.enable({ emitEvent: false });
    this.customerDetailsFormControls.permanentAddressCity.enable({ emitEvent: false });
    this.customerDetailsFormControls.isGstNumber.enable({ emitEvent: false });
    this.customerDetailsFormControls.gstStateName.enable({ emitEvent: false });
    this.customerDetailsFormControls.gstinNumber.enable({ emitEvent: false });
    this.customerDetailsFormControls.gstinNumber1.enable({ emitEvent: false });
    this.customerDetailsFormControls.gstinNumber2.enable({ emitEvent: false });
    this.customerDetailsFormControls.gstinNumber3.enable({ emitEvent: false });
  }

  async checkPaymentLimitAndSubmissionDateLimit(stage: string, isMultipleProposal?: boolean, proposalNos?: any, productTypeId?: any, productCode?: any): Promise<boolean> {
    const payload = {
      premiumAmount: this.paymentDetailsForm?.getRawValue()?.amount || '0',
      userId: this.motorService.parentImdCode || this.motorService?.smFormControls?.intermediaryCode?.value || this.commonService.getUserName(),
      productTypeId: this.motorService.productTypeId || productTypeId || '',
      productCode: this.motorService.productCode || productCode || '',
      status: stage,
      policyNumber: this.proposalNo || '',
      remarks: "EcoverIssue",
      multipleProposal: isMultipleProposal,
      proposalNos: proposalNos,
      byPassValidation: this.byPassValidation
    };

    try {
      const response = await firstValueFrom(this.insightService.cancelPolicy(payload));
      if (response?.status === 200) {
        const result = response.result;
        const rejectedAmountExceed = result?.rejectedAmountExceed;
        const rejectedSubmissionLogic = result?.rejectedSubmissionLogic;
        const rejectedOtherReasons = result?.rejectedOtherReasons;

        const hasRejections =
          (rejectedAmountExceed && Object.keys(rejectedAmountExceed).length > 0) ||
          (rejectedSubmissionLogic && Object.keys(rejectedSubmissionLogic).length > 0) ||
          (rejectedOtherReasons && Object.keys(rejectedOtherReasons).length > 0);

        if (!hasRejections) {
          return true;
        } else {
          let errorMessages: string[] = [];

          const formatErrors = (rejectedObj: any) => {
            for (const reason in rejectedObj) {
              if (Object.prototype.hasOwnProperty.call(rejectedObj, reason)) {
                const proposals = rejectedObj[reason].join(', ');
                errorMessages.push(`${reason}: ${proposals}`);
              }
            }
          };

          formatErrors(rejectedAmountExceed);
          formatErrors(rejectedSubmissionLogic);
          formatErrors(rejectedOtherReasons);

          this.notificationService.showError('', errorMessages.join('\n'));
          return false;
        }
      } else {
        this.notificationService.showError('', response?.message || 'Something went wrong');
        return false;
      }


    } catch (error) {
      return false;
    }
  }

  async checkPaymentLimitAndSubmissionDateLimitForAll(stage: string, proposalSearchResult: any): Promise<boolean> {
    const payload = {
      premiumAmount: proposalSearchResult?.premium_amount || '',
      userId: proposalSearchResult?.intermediary_code || '',
      productTypeId: proposalSearchResult?.productTypeId || '',
      productCode: proposalSearchResult?.product_code || '',
      status: stage || '',
      policyNumber: proposalSearchResult?.proposalNo || '',
      remarks: "EcoverIssue"
    };

    try {
      const response = await firstValueFrom(this.insightService.cancelPolicy(payload));
      if (response && response.status === 200 && response.message) {
        return true;
      } else {
        this.notificationService.showError('', response.message);
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  showChassisIDV(chassisIDv) {
    if (this.isDeviations) {
      this.motorService.isChassisIdvApproved = (chassisIDv > this.motorService.chassisIdvHigherValue) || (chassisIDv < this.motorService.chassisIdvLowerValue);
    }
    else {
      this.motorService.isChassisIdvApproved = false;
    }
  }

  checkPricingDeviation(BRMSIdv?: any) {
    this.motorService.brmsODDiscount = BRMSIdv;
    if (this.isDeviations) {
      this.motorService.isFromPricingDeviation = (this.motorService.deviationForProposal?.pricing || this.motorService.deviationForProposal?.isIIBDeviationPresent) ? true : false;
      if (this.motorService.isFromPricingDeviation) {
        this.setValueForPricing(this.motorService.approvedODDiscount);
      }
      else {
        this.setValueForPricing(BRMSIdv);
      }
    }
    else {
      this.motorService.isFromPricingDeviation = false;
      this.setValueForPricing(BRMSIdv);
    }
  }

  setValueForPricing(value) {
    this.motorService.maxDiscountValue = value;
    this.motorService.setMaxDiscountValidation(value);
  }

  async getConsolidatedPayment(): Promise<boolean> {
    try {
      const res = await lastValueFrom(this.quoteService.getConsolidatedPaymentStatus());
      if (res && res.length > 0) {
        const showConsolidatedPayment = res[0]?.udf1;
        const isTrue = showConsolidatedPayment === "1";
        return isTrue;
      }
      else {
        return false;
      }
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async getGatewayPayUPage(proposalList: any) {
    const res = await lastValueFrom(this.quoteService.payUPage(proposalList));
    if (!res) {
      this.notificationService.showError('Failed to get Payment Window!', 'Failed!');
      return null;
    }
    else if (res?.error) {
      this.notificationService.showError(res?.error?.errorMessage, 'Failed!');
    }
    else {
      return res;
    }
  }
  disableGrossVehicleWeight() {
    if (this.pcvVehicleClassCode.includes(this.motorService.vehicleClassCode)) {
      this.motorService.vehicleForm.controls.grossVehicleWeight.disable();
    } else if (!this.motorService.isSaveProposalDone) {
      this.motorService.vehicleForm.controls.grossVehicleWeight.enable();
    }
  }

  onCopyPasteNameRestrictWithSingleSpace(event: ClipboardEvent, maxLength?: number, isFromNominee?: boolean): void {
    event.preventDefault();
    let pastText = event.clipboardData?.getData('Text') || '';
    pastText = pastText.replace(/[^a-zA-Z ]+/g, '').replace(/\s+/g, ' ').trim();
    let inputElement = event.target as HTMLInputElement;
    const regex = /^[a-zA-Z ]$/;
    inputElement.value = pastText;
    let inputCopyPasteValue = inputElement?.value;
    if (inputCopyPasteValue) {
      this.motorService.CopyRestrictAlertScriptcharacter(inputCopyPasteValue, event);
    }
    if (maxLength && inputElement.value.length + pastText.length > maxLength && !regex.test(pastText)) {
      event.preventDefault();
      return;
    }

    if (isFromNominee) {
      this.nomineeDetailFormControl.nomineeName.patchValue(pastText);
    }
  }

  async getFinancierName() {
    let value = this.financierForm.get('financierName')?.value;

    if (value && value?.length >= 3) {
      const res = await lastValueFrom(this.quoteService.getFinancierListName(value));
      if (res?.status === 200) {
        console.log(res?.status, "res?.status 112345");
        return res.result;
      }
    }
    return [];
  }

  async getPaymentPGTypeCheck() {
    const res = await lastValueFrom(this.quoteService.getPaymentPGTypeCheck());
    if (!res) {
      this.notificationService.showError('Failed to get Payment Window!', 'Failed!');
      return null;
    }
    else {
      return res[0];
    }
  }
}